<template>
  <Adhoc_regularvehicle-components>
      <div class="animated fadeIn mt-5 pt-3">
          <b-row>
              <b-col sm="12">
                  <b-row class="mb-4">
                      <input type="hidden" name="isactiveId" id="isactiveId" value="" />
                      <input
                      type="hidden"
                      name="deliveryagentmasterId"
                      id="deliveryagentmasterId"
                      value=""
                      />
                      <b-col md="4" class="my-1">
                        <b-form-group label-cols-sm="3" label="Filter" class="mb-0">
                        <b-input-group>
                            <b-form-input
                            v-model="searchfilter"
                            placeholder="Type to Search"
                            ></b-form-input>
                        </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col md="2">
                      <b-button @click="displaydata(1)" variant="primary">Search</b-button>&nbsp;
                      <b-button @click="Clearsearch()" variant="danger">Clear</b-button>
                    </b-col>
                      <b-col md="4" class="my-1">
                      <b-form-group label-cols-sm="3" label="Sort" class="mb-0">
                          <b-input-group>
                          <b-form-select v-model="sortBy" :options="sortOptions">
                              <option slot="first" :value="null">-- none --</option>
                          </b-form-select>
                          <b-form-select
                              v-model="sortDesc"
                              :disabled="!sortBy"
                              slot="append"
                          >
                              <option :value="false">Asc</option>
                              <option :value="true">Desc</option>
                          </b-form-select>
                          </b-input-group>
                      </b-form-group>
                      </b-col>
                      <b-col md="1">
                          <b-button v-if="totalRows>0"
                              @click="downloadadhocreport()"
                              size="md"
                              variant="primary"
                              >Download</b-button
                          >
                      </b-col>
                  </b-row>
                  <b-col sm="12" class="text-right">
                      <p>
                      <b
                          >Total Records :<span style="color:red;">{{
                          totalRows
                          }}</span></b
                      >
                      </p>
                      <!-- this.totalRows  -->
                  </b-col>
                  <b-col sm="12">
                      <b-table
                      show-empty
                      responsive
                      :busy="isBusy"
                      :items="items"
                      :fields="fields"
                      :current-page="currentPage"
                      :per-page="perPage"
                      :bordered="bordered"
                      :filter="filter"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      :sort-direction="sortDirection"
                      @filtered="onFiltered"
                      >
                      <div slot="table-busy" class="text-center text-danger my-2">
                          <b-spinner class="align-middle"></b-spinner>
                          <strong>Loading...</strong>
                      </div>
                       <template slot="vehicle_origin_city" slot-scope="row">
                          <span style="word-break: break-all;width:30%;">{{ row.item.vehicle_origin_city }}
                        </span
                          >
                      </template>

                      <template slot="drivername" slot-scope="row">
                          <span
                          >{{ row.item.driverfirstname }}
                          {{ row.item.driverlastname }}</span
                          >
                      </template>
                      <template slot="fullvehicleno" slot-scope="row">
                          <span> {{ row.item.fullvehicleno }}</span>
                      </template>

                      <!-- <template slot="vehicle_type" slot-scope="row">
                          <span> {{ }}</span>
                      </template> -->
                      <template slot="vehicle_type_text" slot-scope="row">
                          <span> {{row.item.vehicletypesizetext}}</span>
                      </template>

                      <template slot="isactive" slot-scope="row">
                        <span
                          @click="toggleInfoModal(row.item)"
                          style="cursor:pointer;"
                        >
                          <span
                            data-toggle="tooltip"
                            title="InActive"
                            v-if="row.item.isactive === '0'"
                          >
                            <span class="badge badge-danger">Inative</span>
                          </span>
                          <span data-toggle="tooltip" title="Active" v-else>
                            <span class="badge badge-success">Active</span>
                          </span>
                        </span>
                      </template>
                      <!-- <template slot="isactive" slot-scope="row">
                          <span  @click="toggleInfoModal(row.item)" style="cursor:pointer;">
                          <span data-toggle="tooltip" title="Active" v-if="row.item.isactive ==='1'" > 
                              <span class="badge badge-success">Active</span>
                          </span>  
                          </template> -->
                          <template slot="createddate" slot-scope="row">
                            <div>
                                {{ row.item.createddate | ConvertTime12hour() }}
                            </div>
                        </template>
                          
                      <template slot="actions" slot-scope="row">
                          <b-button :disabled="isReadOnly"
                          size="sm"
                          @click="editinfoModal(row.item), editvehicleCityWH(row.item)"
                          data-toggle="tooltip"
                          title="Update Adhoc Vehicle Details"
                          class="mr-1"
                          >
                          Edit
                          </b-button>
                          <b-button :disabled="isReadOnly"
                  size="sm"
                  title="Change Password"
                  @click="changePassword(row.item)"
                >
                  <i class="fa fa-key"></i>
                </b-button>&nbsp;
                      </template>
                      </b-table>
                  </b-col>
                  <b-col md="12" class="my-1" >
                    <paginate 
                    v-model="pageNum"
                    :page-count="noofpages"
                    :page-range="10"
                    :margin-pages="2"
                    :click-handler="clickCallback"
                    :prev-text="'Prev'"
                    :next-text="'Next'"
                    :container-class="'pagination'"
                    :page-class="'page-item'">
                    </paginate>
                </b-col>   
        
                  <b-modal
                      id="testModal"
                      size="xl"
                      title="Update Vehicle Details"
                      v-model="editAgentMaster"
                      @ok="editAgentMaster = false"
                      hide-footer
                  >
                  <div id="overlayModal">
                      <div class="loaderModal"></div>
                  </div>
                      <template slot="default" slot-scope="{ hide }">
                      <div>
                          <b-form-group v-slot="{ ariaDescribedby }">
                          <b-form-radio-group
                              id="radio-group-1"
                              v-model="vehicletype"
                              :options="options"
                              :aria-describedby="ariaDescribedby"
                              name="radio-options"
                          ></b-form-radio-group>
                          </b-form-group>
                      </div>

                      <b-form
                          @submit.prevent="validateForm5('form-5')"
                          data-vv-scope="form-5"
                      >
                          <div v-if="vehicletype == 'regular_vehicle'">
                          <h6 style="text-align:center" class="m-4"><b>Upadate Admin</b></h6>
                          <b-row>
                              <b-col md="6" v-if="userType==1">
                              <b-row>
                                  <b-col md="3">
                                  <label><b>Select Admin</b></label>&nbsp;<span style="color: red;">*</span>
                                  </b-col>
                                  <b-col md="9">
                                  <div id="container">
                                       <b-form-group>
                                      <ejs-multiselect
                                      id="multi_select"
                                      placeholder="Select Admin"
                                      v-model="valueAdmin"
                                      @change="selectAdmin"
                                      :dataSource="optionsAdmin"
                                      :fields="fieldAdmin"
                                      ></ejs-multiselect>
                                      </b-form-group>
                                  </div>
                                  </b-col>
                              </b-row>
                              
                              </b-col>

                              <b-col md="6">
                              <b-row>
                                  <b-col md="3">
                                  <label><b>Select City</b></label>&nbsp;<span style="color: red;">*</span>
                                  </b-col>
                                  <b-col md="9">
                                  <div id="container">
                                      <b-form-group>
                                      <ejs-multiselect
                                          id="multi_select"
                                          placeholder="Select City"
                                          v-model="valueWHAdmin"
                                          @change="selectWHAdmin"
                                          :dataSource="warehouseAdmin"
                                          :fields="fieldwhAdmin"
                                      ></ejs-multiselect>
                                      </b-form-group>
                                  </div>
                                  </b-col>
                              </b-row>
                              </b-col>
                          </b-row>
                          <br />
                          <hr />
                          <h6 style="text-align:center" class="mt-3">
                              <b>Update Vehicle Info</b>
                          </h6>
                          <br />
                          <b-row>
                              <b-col sm="4">
                              <b-row>
                                  <b-col sm="5" class="pr-0">
                                  <label><b>Vehicle Name</b></label>&nbsp;<span style="color: red;">*</span>
                                  </b-col>
                                  <b-col sm="7" class="pl-0">
                                    <b-form-group>
                                      <v-select v-model="customer.vehiclename" name="vehicle_name" :options="vehicleNameOptions" @input="addVehicleName" placeholder="-- Select Vehicle Name --" v-validate="'required'"
                                      :class="{
                                        input: true,
                                        'is-invalid': errors.has('form-5.vehicle_name'),
                                      }"></v-select>
                                        <b-input-group class="mb-3">
                                          <span
                                            style="width:240px"
                                            v-show="errors.has('form-5.vehicle_name')"
                                            class="help text-danger"
                                          >{{
                                            errors.first("form-5.vehicle_name")
                                          }}</span>
                                        </b-input-group>                               
                                  </b-form-group>
                                  </b-col>
                              </b-row>
                              </b-col>

                              <b-col sm="4" v-if="vehiclenametext">
                              <b-row>
                                  <b-col sm="5" class="pr-0">
                                  <label><b>Vehicle Name</b></label>&nbsp;<span style="color: red;">*</span>
                                  </b-col>
                                  <b-col sm="7" class="pl-0">
                                    <b-form-group>
                                      <b-form-input
                                        type="text"
                                        name="vehicle name"
                                        v-model="customer.vehiclenametext"
                                        v-validate="'required|min:3|max:30'"
                                        :class="{
                                          input: true,
                                          'is-invalid': errors.has('form-5.vehicle name'),
                                        }"
                                        placeholder="Enter Vehicle Name"
                                      >
                                      </b-form-input>
                                      <b-input-group class="mb-3">
                                        <span class="icon has-text-warning">
                                          <i
                                            class="fa fa-warning"
                                            v-show="errors.has('vehicle name')"
                                          ></i>
                                        </span>
                                        <span
                                          style="width:240px"
                                          v-show="errors.has('form-5.vehicle name')"
                                          class="help text-danger"
                                        >{{ errors.first("form-5.vehicle name") }}</span>
                                      </b-input-group>
                                  </b-form-group>
                                  </b-col>
                              </b-row>
                              </b-col>

                              <b-col sm="4">
                              <b-row>
                                  <b-col sm="5" class="pr-0 pl-0">
                                  <label><b>Vehicle Number</b></label>&nbsp;<span style="color: red;">*</span>
                                  </b-col>
                                  <b-col sm="7" class="pl-0">
                                  <b-form-group>
                                      <b-form-input
                                      class="input"
                                      type="text"
                                      v-model="customer.editvehicleno"
                                      name="vehicleno"
                                      v-validate="'required'"
                                      disabled
                                      placeholder="Enter Vehicle Number"
                                      >
                                      </b-form-input>
                                  </b-form-group>
                                  </b-col>
                              </b-row>
                              </b-col>

                              <b-col sm="4">
                              <b-row>
                                  <b-col sm="5" class="pr-0 pl-0">
                                  <label><b>Registration No</b></label>&nbsp;<span style="color: red;">*</span>
                                  </b-col>
                                  <b-col sm="7" class="pl-0">
                                  <b-form-group>
                                      <b-form-input
                                      type="text"
                                      name="registration_no"
                                      v-model="customer.registration_no"
                                      v-validate="'required'"
                                      :class="{
                                          input: true,
                                          'is-invalid': errors.has('form-5.registration_no'),
                                      }"
                                      placeholder="Enter Registration Certificate No"
                                      >
                                      </b-form-input>
                                      <span
                                      style="width:100px"
                                      v-show="errors.has('form-5.registration_no')"
                                      class="help text-danger"
                                      >{{ errors.first("form-5.registration_no") }}</span
                                      >
                                  </b-form-group>
                                  </b-col>
                              </b-row>
                              </b-col>

                              <!-- <b-col sm="4">
                              <b-row>
                                  <b-col sm="5" class="pr-0">
                                  <label><b>Vehicle Type</b></label>&nbsp;<span style="color: red;">*</span>
                                  </b-col>
                                  <b-col sm="7" class="pl-0">
                                  <b-form-group>
                                      <b-form-select
                                      class="input"
                                      type="text"
                                      v-model="customer.vehicletype"
                                      name="vehicletype"
                                      maxlength="6"
                                      v-validate="'required'"
                                      :class="{
                                          input: true,
                                          'is-invalid': errors.has('form-5.vehicletype'),
                                      }"
                                      >
                                      <option :value="SelectVehicletype" active
                                          >--Select--</option
                                      >
                                      <option value="inter">Inter City</option>
                                      <option value="intra">Intra City</option>
                                      
                                      </b-form-select>
                                      <span
                                      style="width:100px"
                                      v-show="errors.has('form-5.vehicletype')"
                                      class="help text-danger"
                                      >{{ errors.first("form-5.vehicletype") }}</span
                                      >
                                  </b-form-group>
                                  </b-col>
                              </b-row>
                              </b-col> -->

                              <b-col sm="4">
                              <b-row>
                                  <b-col sm="5" class="pr-0">
                                  <label><b>Movement Type</b></label>&nbsp;<span style="color: red;">*</span>
                                  </b-col>
                                  <b-col sm="7" class="pl-0">
                                  <b-form-group>
                                      <b-form-select
                                      class="input"
                                      type="text"
                                      v-model="customer.vehicletype"
                                      name="movementtype"
                                      maxlength="6"
                                      v-validate="'required'"
                                      :class="{
                                          input: true,
                                          'is-invalid': errors.has('form-5.movementtype'),
                                      }"
                                      >
                                      <option :value="SelectVehicletype" active
                                          >--Select--</option
                                      >
                                      <option value="inter">Inter City</option>
                                      <option value="intra">Intra City</option>
                                      
                                      </b-form-select>
                                      <span
                                      style="width:100px"
                                      v-show="errors.has('form-5.movementtype')"
                                      class="help text-danger"
                                      >{{ errors.first("form-5.movementtype") }}</span
                                      >
                                  </b-form-group>
                                  </b-col>
                              </b-row>
                              </b-col>

                              <!-- <b-col sm="4">
                              <b-row>
                                  <b-col sm="5" class="pr-0">
                                  <label><b>Make Type</b></label>&nbsp;<span style="color: red;">*</span>
                                  </b-col>
                                  <b-col sm="7" class="pl-0">
                                  <b-form-group>
                                      <b-form-input
                                      class="input"
                                      type="text"
                                      v-model="customer.vehiclemake"
                                      name="vehiclemake"
                                      v-validate="'required'"
                                      :class="{
                                          input: true,
                                          'is-invalid': errors.has('form-5.vehiclemake'),
                                      }"
                                      placeholder="Enter Vehicle Make"
                                      >
                                      </b-form-input>
                                      <span
                                      style="width:100px"
                                      v-show="errors.has('form-5.vehiclemake')"
                                      class="help text-danger"
                                      >{{ errors.first("form-5.vehiclemake") }}</span
                                      >
                                  </b-form-group>
                                  </b-col>
                              </b-row>
                              </b-col> -->

                              <b-col sm="4">
                              <b-row>
                                  <b-col sm="5" class="pr-0">
                                  <label><b>Vehicle Type</b></label>&nbsp;<span style="color: red;">*</span>
                                  </b-col>
                                  <b-col sm="7" class="pl-0">
                                    <b-form-group>
                                      <v-select v-model="customer.vehicletypesize" name="vehicletypesize" :options="vehicleTypeSizeOptions" @input="addVehicleTypeSize" placeholder="-- Select Vehicle Type --" v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'is-invalid': errors.has('form-1.vehicletypesize'),
                                        }"></v-select>
                                        <b-input-group class="mb-3">
                                          <span
                                            style="width:240px"
                                            v-show="errors.has('form-1.vehicletypesize')"
                                            class="help text-danger"
                                          >{{
                                            errors.first("form-1.vehicletypesize")
                                          }}</span>
                                        </b-input-group>                               
                                    </b-form-group>
                                  </b-col>
                              </b-row>
                              </b-col>

                              <b-col sm="4" v-if="vehicletypesizetext">
                              <b-row>
                                  <b-col sm="5" class="pr-0">
                                  <label><b>Vehicle Type</b></label>&nbsp;<span style="color: red;">*</span>
                                  </b-col>
                                  <b-col sm="7" class="pl-0">
                                    <b-form-group>
                                      <b-form-input
                                        type="text"
                                        name="vehicle_type_size"
                                        v-model="customer.vehicletypesizetext"
                                        v-validate="'required|min:3|max:30'"
                                        :class="{
                                          input: true,
                                          'is-invalid': errors.has('form-1.vehicle_type_size'),
                                        }"
                                        placeholder="Enter Vehicle Type"
                                      >
                                      </b-form-input>
                                      <b-input-group class="mb-3">
                                        <span class="icon has-text-warning">
                                          <i
                                            class="fa fa-warning"
                                            v-show="errors.has('vehicle_type_size')"
                                          ></i>
                                        </span>
                                        <span
                                          style="width:240px"
                                          v-show="errors.has('form-1.vehicle_type_size')"
                                          class="help text-danger"
                                        >{{ errors.first("form-1.vehicle_type_size") }}</span>
                                      </b-input-group>
                                    </b-form-group>
                                  </b-col>
                              </b-row>
                              </b-col>

                              <b-col sm="4">
                              <b-row>
                                  <b-col sm="5" class="pr-0">
                                  <label><b>Vol Weight</b></label>&nbsp;<span style="color: red;">*</span>
                                  </b-col>
                                  <b-col sm="7" class="pl-0">
                                  <b-form-group>
                                      <b-form-input
                                      class="input"
                                      type="text"
                                      v-model="customer.vehicleweightcarrying"
                                      name="vehicleweightcarrying"
                                      v-validate="'required|decimal:3'"
                                      :class="{
                                          input: true,
                                          'is-invalid': errors.has('form-5.vehicleweightcarrying'),
                                      }"
                                      placeholder="Enter Vehicle Weight Capacity"
                                      >
                                      </b-form-input>
                                      <span
                                      style="width:100px"
                                      v-show="errors.has('form-5.vehicleweightcarrying')"
                                      class="help text-danger"
                                      >{{
                                          errors.first("form-5.vehicleweightcarrying")
                                      }}</span
                                      >
                                  </b-form-group>
                                  </b-col>
                              </b-row>
                              </b-col>

                              <b-col sm="4">
                              <b-row>
                                  <b-col sm="5" class="pr-0">
                                  <label><b>Phy Weight</b></label>&nbsp;<span style="color: red;">*</span>
                                  </b-col>
                                  <b-col sm="7" class="pl-0">
                                  <b-form-group>
                                      <b-form-input
                                      class="input"
                                      type="text"
                                      v-model="customer.vehiclephysicalweight"
                                      name="vehiclephysicalweight"
                                      v-validate="'required|decimal:3'"
                                      :class="{
                                          input: true,
                                          'is-invalid': errors.has('form-5.vehiclephysicalweight'),
                                      }"
                                      placeholder="Enter Vehicle Weight Capacity"
                                      >
                                      </b-form-input>
                                      <span
                                      style="width:100px"
                                      v-show="errors.has('form-5.vehiclephysicalweight')"
                                      class="help text-danger"
                                      >{{
                                          errors.first("form-5.vehiclephysicalweight")
                                      }}</span
                                      >
                                  </b-form-group>
                                  </b-col>
                              </b-row>
                              </b-col>

                              <b-col sm="4">
                              <b-row>
                                  <b-col sm="5" class="pr-0 pl-0">
                                  <label><b>Dimensions Weight</b></label>&nbsp;<span style="color: red;">*</span>
                                  </b-col>
                                  <b-col sm="7" class="pl-0">
                                  <b-form-group>
                                      <b-form-input
                                      class="input"
                                      type="text"
                                      v-model="customer.vehicledimensionsweight"
                                      name="vehicledimensionsweight"
                                      v-validate="'required|decimal:3'"
                                      :class="{
                                          input: true,
                                          'is-invalid': errors.has('form-5.vehicledimensionsweight'),
                                      }"
                                      placeholder="Enter Vehicle Weight Capacity"
                                      >
                                      </b-form-input>
                                      <span
                                      style="width:100px"
                                      v-show="errors.has('form-5.vehicledimensionsweight')"
                                      class="help text-danger"
                                      >{{
                                          errors.first("form-5.vehicledimensionsweight")
                                      }}</span
                                      >
                                  </b-form-group>
                                  </b-col>
                              </b-row>
                              </b-col>

                              <b-col sm="4">
                              <b-row>
                                  <b-col sm="4" class="pr-0 pl-0">
                                  <label><b>Fuel Type</b></label>&nbsp;<span style="color: red;">*</span>
                                  </b-col>
                                  <b-col sm="8" class="pl-0">
                                    <b-form-group>
                                      <v-select v-model="customer.fueltype" name="fueltype" :options="fuelTypeOptions" placeholder="-- Select Fuel Type --" v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'is-invalid': errors.has('form-1.fueltype'),
                                        }"></v-select>
                                      <b-input-group class="mb-3">
                                        <span
                                          style="width:240px"
                                          v-show="errors.has('form-1.fueltype')"
                                          class="help text-danger"
                                        >{{
                                          errors.first("form-1.fueltype")
                                        }}</span>
                                      </b-input-group>                               
                                    </b-form-group>
                                  </b-col>
                              </b-row>
                              </b-col>
                          </b-row>
                          <hr />
                          <br />
                          <h6 style="text-align:center"><b>Update Driver Info</b></h6>
                          <br />
                          <b-row>
                              <b-col sm="4">
                              <b-row>
                                  <b-col sm="4" class="pr-0">
                                  <label><b>First Name</b></label>&nbsp;<span style="color: red;">*</span>
                                  </b-col>
                                  <b-col sm="8" class="pl-0">
                                  <b-form-group>
                                      <b-form-input
                                      class="input"
                                      type="text"
                                      id="driverfirstname"
                                      name="driverfirstname"
                                      v-model="customer.driverfirstname"
                                      v-validate="'required|alpha|min:3|max:30'"
                                      :class="{
                                          input: true,
                                          'is-invalid': errors.has('form-5.driverfirstname'),
                                      }"
                                      placeholder="Enter First Name"
                                      >
                                      </b-form-input>
              
                                      <span
                                      style="width:100px"
                                      v-show="errors.has('form-5.driverfirstname')"
                                      class="help text-danger"
                                      >{{ errors.first("form-5.driverfirstname") }}</span
                                      >
                                  </b-form-group>
                                  </b-col>
                              </b-row>
                              </b-col>
                              <b-col sm="4">
                              <b-row>
                                  <b-col sm="4" class="pr-0">
                                  <label><b>Last Name</b></label>&nbsp;<span style="color: red;">*</span>
                                  </b-col>
                                  <b-col sm="8" class="pl-0">
                                  <b-form-group>
                                      <b-form-input
                                      class="input"
                                      type="text"
                                      id="driverlastname"
                                      name="driverlastname"
                                      v-model="customer.driverlastname"
                                      v-validate="'required|alpha|min:3|max:30'"
                                      :class="{
                                          input: true,
                                          'is-invalid': errors.has('form-5.driverlastname'),
                                      }"
                                      placeholder="Enter First Name"
                                      >
                                      </b-form-input>
              
                                      <span
                                      style="width:100px"
                                      v-show="errors.has('form-5.driverlastname')"
                                      class="help text-danger"
                                      >{{ errors.first("form-5.driverlastname") }}</span
                                      >
                                  </b-form-group>
                                  </b-col>
                              </b-row>
                              </b-col>
                              <b-col sm="4">
                              <b-row>
                                  <b-col sm="4" class="pr-0">
                                  <label><b>Mobile No</b></label>&nbsp;<span style="color: red;">*</span>
                                  </b-col>
                                  <b-col sm="8" class="pl-0">
                                  <b-form-group>
                                      <b-form-input
                                      class="input"
                                      type="text"
                                      v-model="customer.mobile_no"
                                      name="mobile_no"
                                      v-validate="'required|digits:10'"
                                      :class="{
                                          input: true,
                                          'is-invalid': errors.has('form-5.mobile_no'),
                                      }"
                                      placeholder="Enter Mobile Number "
                                      >
                                      </b-form-input>
                                      <span
                                      style="width:100px"
                                      v-show="errors.has('form-5.mobile_no')"
                                      class="help text-danger"
                                      >{{ errors.first("form-5.mobile_no") }}</span
                                      >
                                  </b-form-group>
                                  </b-col>
                              </b-row>
                              </b-col>
                              <b-col sm="4">
                              <b-row>
                                  <b-col sm="4" class="pr-0">
                                  <label><b>Alt Mobile No</b></label>&nbsp;<span style="color: red;">*</span>
                                  </b-col>
                                  <b-col sm="8" class="pl-0">
                                  <b-form-group>
                                      <b-form-input
                                      class="input"
                                      type="text" maxlength="10"
                                      v-model="customer.altmobile_no"
                                      name="altmobile_no"
                                      v-validate="'required|digits:10'"
                                      :class="{
                                          input: true,
                                          'is-invalid': errors.has('form-5.altmobile_no'),
                                      }"
                                      placeholder="Enter Mobile Number "
                                      >
                                      </b-form-input>
                                      <span
                                      style="width:100px"
                                      v-show="errors.has('form-5.altmobile_no')"
                                      class="help text-danger"
                                      >{{ errors.first("form-5.altmobile_no") }}</span
                                      >
                                  </b-form-group>
                                  </b-col>
                              </b-row>
                              </b-col>
                              <b-col sm="4">
                              <b-row>
                                  <b-col sm="4" class="pr-0 pl-0">
                                  <label><b>Driving License</b></label>&nbsp;<span style="color: red;">*</span>
                                  </b-col>
                                  <b-col sm="8" class="pl-0">
                                  <b-form-group>
                                      <b-form-input
                                      class="input"
                                      type="text"
                                      v-model="customer.driving_license"
                                      name="driving_license"
                                      v-validate="'required'"
                                      :class="{
                                          input: true,
                                          'is-invalid': errors.has('form-5.driving_license'),
                                      }"
                                      placeholder="Enter Driving License"
                                      >
                                      </b-form-input>
                                      <span
                                      style="width:100px"
                                      v-show="errors.has('form-5.driving_license')"
                                      class="help text-danger"
                                      >{{ errors.first("form-5.driving_license") }}</span
                                      >
                                  </b-form-group>
                                  </b-col>
                              </b-row>
                              </b-col>
                              <b-col sm="4">
                              <b-row>
                                  <b-col sm="4" class="pr-0">
                                  <label><b>Status</b></label>&nbsp;<span style="color: red;">*</span>
                                  </b-col>
                                  <b-col sm="8" class="pl-0">
                                  <b-form-group>
                                      <b-form-select
                                      v-model="customer.isactive"
                                      name="status"
                                      v-validate="'required|'"
                                      :class="{
                                          input: true,
                                          'is-invalid': errors.has('form-5.status'),
                                      }"
                                      >
                                      <option :value="selectstatus">--Select--</option>
                                      <option value="1">Active</option>
                                      <option value="0">InActive</option>
                                      </b-form-select>
                  
                                      <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                          <i
                                          class="fa fa-warning help text-danger"
                                          v-show="errors.has('form-5.status')"
                                          >{{ errors.first("form-5.status") }}</i
                                          >
                                      </span>
                                      </b-input-group>
                                  </b-form-group>
                                  </b-col>
                              </b-row>
                              </b-col>
                          </b-row>
                          <hr />
                          <br />
                          <h6 style="text-align:center"><b>Update Helper Info</b></h6>
                          <br />
                          <b-row>
                              <b-col sm="4">
                              <b-row>
                                  <b-col sm="4" class="pr-0">
                                  <label><b>First Name</b></label>&nbsp;<span style="color: red;">*</span>
                                  </b-col>
                                  <b-col sm="8" class="pl-0">
                                  <b-form-group>
                                      <b-form-input
                                      class="input"
                                      type="text"
                                      id="helperfirstname"
                                      name="helperfirstname"
                                      v-model="customer.helperfirstname"
                                      v-validate="'required|alpha|min:3|max:30'"
                                      :class="{
                                          input: true,
                                          'is-invalid': errors.has('form-5.helperfirstname'),
                                      }"
                                      placeholder="Enter First Name"
                                      >
                                      </b-form-input>
              
                                      <span
                                      style="width:100px"
                                      v-show="errors.has('form-5.helperfirstname')"
                                      class="help text-danger"
                                      >{{ errors.first("form-5.helperfirstname") }}</span
                                      >
                                  </b-form-group>
                                  </b-col>
                              </b-row>
                              </b-col>
                              <b-col sm="4">
                              <b-row>
                                  <b-col sm="4" class="pr-0">
                                  <label><b>Last Name</b></label>&nbsp;<span style="color: red;">*</span>
                                  </b-col>
                                  <b-col sm="8" class="pl-0">
                                  <b-form-group>
                                      <b-form-input
                                      class="input"
                                      type="text"
                                      id="helperlastname"
                                      name="helperlastname"
                                      v-model="customer.helperlastname"
                                      v-validate="'required|alpha|min:3|max:30'"
                                      :class="{
                                          input: true,
                                          'is-invalid': errors.has('form-5.helperlastname'),
                                      }"
                                      placeholder="Enter First Name"
                                      >
                                      </b-form-input>
              
                                      <span
                                      style="width:100px"
                                      v-show="errors.has('form-5.helperlastname')"
                                      class="help text-danger"
                                      >{{ errors.first("form-5.helperlastname") }}</span
                                      >
                                  </b-form-group>
                                  </b-col>
                              </b-row>
                              </b-col>
                              <b-col sm="4">
                              <b-row>
                                  <b-col sm="4" class="pr-0">
                                  <label><b>Mobile No</b></label>&nbsp;<span style="color: red;">*</span>
                                  </b-col>
                                  <b-col sm="8" class="pl-0">
                                  <b-form-group>
                                      <b-form-input
                                      class="input"
                                      type="text"
                                      id="addmobilenumber"
                                      name="mobilenumber"
                                      maxlength="10"
                                      v-model="customer.helpermobilenumber"
                                      v-validate="'required|digits:10'"
                                      :class="{
                                          input: true,
                                          'is-invalid': errors.has('form-5.mobilenumber'),
                                      }"
                                      placeholder="Enter Mobile Number"
                                      >
                                      </b-form-input>
              
                                      <span
                                      style="width:100px"
                                      v-show="errors.has('form-5.mobilenumber')"
                                      class="help text-danger"
                                      >{{ errors.first("form-5.mobilenumber") }}</span
                                      >
                                  </b-form-group>
                                  </b-col>
                              </b-row>
                              </b-col>
                              <b-col sm="4">
                              <b-row>
                                  <b-col sm="4" class="pr-0">
                                  <label><b>Alt Mobile No</b></label>&nbsp;<span style="color: red;">*</span>
                                  </b-col>
                                  <b-col sm="8" class="pl-0">
                                  <b-form-group>
                                      <b-form-input
                                      class="input"
                                      type="text"
                                      id="addaltenatemobilenumber"
                                      name="helperaltmobilenumber"
                                      maxlength="10"
                                      v-model="customer.helperaltmobilenumber"
                                      v-validate="'required|digits:10'"
                                      :class="{
                                          input: true,
                                          'is-invalid': errors.has(
                                          'form-5.helperaltmobilenumber'
                                          ),
                                      }"
                                      placeholder="Enter Alternate Mobile Number"
                                      >
                                      </b-form-input>
                                      <span
                                      style="width:100px"
                                      v-show="errors.has('form-5.helperaltmobilenumber')"
                                      class="help text-danger"
                                      >{{
                                          errors.first("form-5.helperaltmobilenumber")
                                      }}</span
                                      >
                                  </b-form-group>
                                  </b-col>
                              </b-row>
                              </b-col>
                          </b-row>
                          <hr />
                          <br />
                          <h6 style="text-align:center">
                              <b>Update Transporter Info</b>
                          </h6>
                          <br />
                          <b-row>
                              <b-col sm="4">
                              <b-row>
                                  <b-col sm="5" class="pr-0">
                                  <label><b>Company Name</b></label>&nbsp;<span style="color: red;">*</span>
                                  </b-col>
                                  <b-col sm="7" class="pl-0">
                                  <b-form-group>
                                      <v-select v-model="transporterCompanyName" :options="optionmailid" @input="updateTextbox" placeholder="-- Select Company --" :class="{
                                              input: true,
                                              'is-invalid': errors.has('form-1.companyname'),
                                          }"></v-select>
                                      <span
                                          v-show="errors.has('form-1.companyname')"
                                          class="help text-danger"
                                          >{{ errors.first("form-1.companyname") }}</span
                                          >
                                  </b-form-group>
                                  </b-col>
                              </b-row>
                              </b-col>
                              <b-col sm="4">
                              <b-form-group label="Transporter Name" :label-cols="4">
                                  <b-form-input
                                  class="input"
                                  type="text"
                                  v-model="customer.driver_contracter_name"
                                  name="driver_contracter_name"
                                  v-validate="'required|alpha_spaces'"
                                  placeholder="Enter Driver Transporter Name"
                                  disabled>
                                  </b-form-input>
                                  <!-- <span
                                  style="width:100px"
                                  v-show="errors.has('form-5.driver_contracter_name')"
                                  class="help text-danger"
                                  >{{ errors.first("form-5.driver_contracter_name") }}</span
                                  > -->
                              </b-form-group>
                              </b-col>
                              <b-col sm="4">
                              <b-form-group label="Mobile No" :label-cols="4">
                                  <b-form-input
                                  class="input"
                                  type="text"
                                  id="contractormobilenumber"
                                  name="mobilenumber"
                                  maxlength="10"
                                  v-model="customer.contractormobilenumber"
                                  placeholder="Enter Mobile Number" disabled>
                                  </b-form-input>
                                  <!-- v-validate="'required|digits:10'"
                                  :class="{
                                      input: true,
                                      'text-danger': errors.has('form-5.mobilenumber'),
                                  }" -->
                                  <!-- <span
                                  style="width:100px"
                                  v-show="errors.has('form-5.mobilenumber')"
                                  class="help text-danger"
                                  >{{ errors.first("form-5.mobilenumber") }}</span
                                  > -->
                              </b-form-group>
                              </b-col>
                              <b-col sm="4">
                              <b-form-group label="Email ID" :label-cols="4" disabled>
                                  <b-form-input
                                  class="input"
                                  type="text"
                                  v-model="customer.contracter_emailid"
                                  name="contracter_emailid"
                                  v-validate="'required|email'"
                                  placeholder="Enter Transporter Email ID" disabled
                                  >
                                  </b-form-input>
                                  <!-- <span
                                  style="width:100px"
                                  v-show="errors.has('form-5.contracter_emailid')"
                                  class="help text-danger"
                                  >{{ errors.first("form-5.contracter_emailid") }}</span
                                  > -->
                              </b-form-group>
                              </b-col>
                              <b-col sm="4">
                              <b-form-group label="Tin Number / GST Number" :label-cols="4">
                                  <b-form-input
                                  name="GST Number" type="text"
                                  v-model="customer.transporter_gstnumber" @input="checkGSTlength(customer.transporter_gstnumber)" 
                                  placeholder="Enter Tin Number / GST Number"
                                  :class="{ input: true, 'is-invalid': errors_GST,
                                  }">
                                  </b-form-input>
                                  <b-input-group class="mb-3">
                                  <span class="icon has-text-warning" v-if="errors_GST">
                                          <i
                                          class="fa fa-warning help text-danger"
                                          >{{ errors_showGST.transporter_gstnumber }}</i
                                          >
                                      </span>
                                  </b-input-group>
                              </b-form-group>
                              </b-col>
                              <b-col sm="4">
                              <button type="button" class="btn btn-outline-success btn-md" v-if="showverifybutton" @click="verifyGSTNo()">Verify</button>&nbsp;
                              <button type="button" class="btn btn-outline-danger btn-md" v-if="removeGST" @click="removevalue()">X</button>
                              </b-col>
                          </b-row>
<hr v-if="vehicle_historylog.length > 0">
<h6 v-if="vehicle_historylog.length > 0" style="text-align:center"><b>Vehicle Details Change History</b></h6>

<div class="col-md-12 px-0 mt-2 ml-0 d-block"  v-if="vehicle_historylog.length > 0">
<table class="table table-bordered table-hover">
 <thead>
   <tr>
       <th>Vehicle Updated From</th>
       <th>Vehicle Updated To</th>
       <th>Vehicle Updated On</th>
       <th>Vehicle Updated By</th>
       <th>Comment</th>


   </tr>
</thead> 
<tbody v-if="vehicle_historylog.length > 0">
 <tr v-for="(data,key) in vehicle_historylog">
        <td>{{data.updated_from == 'adhoc' ? data.updated_from : 'Regular' }}</td>
        <td>{{data.updated_to == 'adhoc' ? data.updated_to : 'Regular'}}</td>
       <td>{{ data.vehicle_updated_on | ConvertTime12hour() }}</td>
       <td>{{data.vehicle_updated_by}}</td>
        <td>{{ data.changecomment }}</td>
   </tr>
</tbody>
</table>
</div>

<hr v-if="vehicle_historylog.length > 0" />
 <br>  

                          </div>
                          <div id="overlayModal">
                          <div class="loaderModal"></div>
                          </div>
                          <div
                          slot="footer"
                          class="text-right"
                          v-if="vehicletype == 'regular_vehicle'"
                          >
                          <b-button
                              type="submit"
                              size="sm"
                              class="mr-4"
                              variant="primary" id="submitButton"

                          >
                              Update</b-button
                          >
                          <b-button size="sm" variant="danger" @click="editcancel()"
                              >cancel</b-button
                          >
                          </div>
                      </b-form>

                      <b-form
                          @submit.prevent="validateForm7('form-7')"
                          data-vv-scope="form-7"
                      >
                          <div v-if="vehicletype == 'adhoc_vehicle'">
                          <h6 class="mt-4 text-center"><b>Update Admin</b></h6>
                          <br />
                          <b-row>
                              <b-col sm="6" v-if="userType==1">
                              <b-row>
                                  <b-col sm="5" class="pr-0">
                                  <label><b>Select Admin</b></label>&nbsp;<span style="color: red;">*</span>
                                  </b-col>
                                  <b-col sm="7" class="pl-0">
                                  <div id="container">
                                      <b-form-group>
                                      <ejs-multiselect
                                      id="multi_select"
                                      placeholder="Select Admin"
                                      v-model="valueAdmin"
                                      @change="selectAdmin"
                                      :dataSource="optionsAdmin"
                                      :fields="fieldAdmin"
                                      ></ejs-multiselect>
                                      </b-form-group>
                                  </div>
                                  </b-col>
                              </b-row>
                              </b-col>

                              <b-col sm="6">
                              <b-row>
                                  <b-col sm="5" class="pr-0">
                                  <label><b>Select City</b></label>&nbsp;<span style="color: red;">*</span>
                                  </b-col>
                                  <b-col sm="7" class="pl-0">
                                  <div id="container">
                                      <b-form-group>
                                      <ejs-multiselect
                                          id="multi_select"
                                          placeholder="Select City"
                                          v-model="valueWHAdmin"
                                          @change="selectWHAdmin"
                                          :dataSource="warehouseAdmin"
                                          :fields="fieldwhAdmin"
                                      ></ejs-multiselect>
                                      </b-form-group>
                                  </div>
                                  </b-col>
                              </b-row>
                              </b-col>
                          </b-row>
                          <hr />
                          <h6 class="mt-4 text-center"><b>Update Driver Info</b></h6>
                          <br />
                          <b-row>
                              <b-col sm="4">
                              <b-row>
                                  <b-col sm="4" class="pr-0">
                                  <label><b>First Name</b></label>&nbsp;<span style="color: red;">*</span>
                                  </b-col>
                                  <b-col sm="8" class="pl-0">
                                  <b-form-group>
                                      <b-form-input
                                      type="text"
                                      name="first name"
                                      v-model="customer.driverfirstname"
                                      v-validate="'required|alpha|min:3|max:30'"
                                      :class="{
                                          input: true,
                                          'is-invalid': errors.has('form-7.first name'),
                                      }"
                                      placeholder="Enter First Name"
                                      >
                                      </b-form-input>
                                      <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                          <i
                                          class="fa fa-warning"
                                          v-show="errors.has('first name')"
                                          ></i>
                                      </span>
                                      <span
                                          style="width:240px"
                                          v-show="errors.has('form-7.first name')"
                                          class="help text-danger"
                                          >{{ errors.first("form-7.first name") }}</span
                                      >
                                      </b-input-group>
                                  </b-form-group>
                                  </b-col>
                              </b-row>
                              </b-col>

                              <b-col sm="4">
                              <b-row>
                                  <b-col sm="4" class="pr-0">
                                  <label><b>Last Name</b></label>&nbsp;<span style="color: red;">*</span>
                                  </b-col>
                                  <b-col sm="8" class="pl-0">
                                  <b-form-group>
                                      <b-input-group class="mb-3">
                                      <b-form-input
                                          class="input"
                                          type="text"
                                          name="last name"
                                          v-model="customer.driverlastname"
                                          v-validate="'required|alpha|min:3|max:30'"
                                          :class="{
                                          input: true,
                                          'is-invalid': errors.has('form-7.last name'),
                                          }"
                                          placeholder="Enter Last Name"
                                      >
                                      </b-form-input>
                                      </b-input-group>
                                      <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                          <i
                                          class="fa fa-warning"
                                          v-show="errors.has('last name')"
                                          ></i>
                                      </span>
                                      <span
                                          style="width:240px"
                                          v-show="errors.has('form-7.last name')"
                                          class="help text-danger"
                                          >{{ errors.first("form-7.last name") }}</span
                                      >
                                      </b-input-group>
                                  </b-form-group>
                                  </b-col>
                              </b-row>
                              </b-col>

                              <b-col sm="4">
                              <b-row>
                                  <b-col sm="4" class="pr-0">
                                  <label><b>Mobile No</b></label>&nbsp;<span style="color: red;">*</span>
                                  </b-col>
                                  <b-col sm="8" class="pl-0">
                                  <b-form-group>
                                      <b-input-group class="mb-3">
                                      <b-form-input
                                          class="input"
                                          type="text"
                                          id="addmobilenumber"
                                          name="mobile number"
                                          maxlength="10"
                                          v-model="customer.drivermobilenumber"
                                          v-validate="'required|digits:10'"
                                          :class="{
                                          input: true,
                                          'is-invalid': errors.has('form-7.mobile number'),
                                          }"
                                          placeholder="Enter Mobile Number"
                                      >
                                      </b-form-input>
                                      </b-input-group>
                                      <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                          <i
                                          class="fa fa-warning"
                                          v-show="errors.has('mobile number')"
                                          ></i>
                                      </span>
                                      <code
                                          v-show="errors.has('form-7.mobile number')"
                                          id="addmblnbrmsg"
                                          class="help text-danger"
                                          >{{ errors.first("form-7.mobile number") }}
                                      </code>
                                      </b-input-group>
                                  </b-form-group>
                                  </b-col>
                              </b-row>
                              </b-col>

                              <b-col sm="4">
                              <b-row>
                                  <b-col sm="4" class="pr-0 pl-0">
                                  <label><b>Vehicle Number</b></label>&nbsp;<span style="color: red;">*</span>
                                  </b-col>
                                  <b-col sm="8" class="pl-0">
                                  <b-form-group>
                                      <b-input-group class="mb-3">
                                      <b-form-input
                                          class="input"
                                          type="text"
                                          v-model="customer.editvehicleno"
                                          name="vehicleno"
                                          id="vehicleno"
                                          disabled
                                          placeholder="Enter Vehicle Number"
                                      >
                                      </b-form-input>
                                      </b-input-group>
                                  </b-form-group>
                                  </b-col>
                              </b-row>
                              </b-col>

                              <b-col sm="4">
                              <b-row>
                                  <b-col sm="4" class="pr-0 pl-0">
                                 

                                  <label><b>Fuel Type</b></label>&nbsp;<span style="color: red;">*</span>
                                  </b-col>
                                  <b-col sm="8" class="pl-0">
                                    <b-form-group>
                                      <v-select v-model="customer.fueltype" name="fueltype" :options="fuelTypeOptions" placeholder="-- Select Fuel Type --" v-validate="'required'"
                                        :class="{
                                          input: true,
                                          'is-invalid': errors.has('form-1.fueltype'),
                                        }"></v-select>
                                      <b-input-group class="mb-3">
                                        <span
                                          style="width:240px"
                                          v-show="errors.has('form-1.fueltype')"
                                          class="help text-danger"
                                        >{{
                                          errors.first("form-1.fueltype")
                                        }}</span>
                                      </b-input-group>                               
                                    </b-form-group>
                                  </b-col>
                              </b-row>
                              </b-col>

                              <b-col sm="4">
                              <b-row>
                                  <b-col sm="4" class="pr-0 pl-0">
                                  <label><b>Driving License</b></label>&nbsp;<span style="color: red;">*</span>
                                  </b-col>
                                  <b-col sm="8" class="pl-0">
                                  <b-form-group>
                                      <b-input-group class="mb-3">
                                      <b-form-input
                                          class="input"
                                          type="text"
                                          v-model="customer.driving_license"
                                          name="drivinglicense"
                                          placeholder="Enter Driving License"
                                          v-validate="'required'"
                                          :class="{
                                          input: true,
                                          'is-invalid': errors.has(
                                              'form-7.drivinglicense'
                                          ),
                                          }"
                                      >
                                      </b-form-input>
                                      </b-input-group>
                                      <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                          <i
                                          class="fa fa-warning"
                                          v-show="errors.has('drivinglicense')"
                                          ></i>
                                      </span>
                                      <code
                                          v-show="errors.has('form-7.drivinglicense')"
                                          id="addmblnbrmsg"
                                          class="help text-danger"
                                          >{{ errors.first("form-7.drivinglicense") }}
                                      </code>
                                      </b-input-group>
                                  </b-form-group>
                                  </b-col>
                              </b-row>
                              </b-col>

                              <b-col sm="4">
                              <b-row>
                                  <b-col sm="4" class="pr-0 pl-0">
                                  <label><b>Registration No</b></label>&nbsp;<span style="color: red;">*</span>
                                  </b-col>
                                  <b-col sm="8" class="pl-0">
                                  <b-form-group>
                                      <b-input-group class="mb-3">
                                      <b-form-input
                                          class="input"
                                          type="text"
                                          v-model="customer.registration_no"
                                          name="registration_no"
                                          v-validate="'required'"
                                          :class="{
                                          input: true,
                                          'is-invalid': errors.has(
                                              'form-7.registration_no'
                                          ),
                                          }"
                                          placeholder="Enter Registration certificate No"
                                      >
                                      </b-form-input>
                                      </b-input-group>
                                      <b-input-group class="mb-3">
                                      <span
                                          v-show="errors.has('form-7.registration_no')"
                                          class="help text-danger"
                                          >{{ errors.first("form-7.registration_no") }}
                                      </span>
                                      </b-input-group>
                                  </b-form-group>
                                  </b-col>
                              </b-row>
                              </b-col>
                              <b-col sm="4">
                              <b-row>
                                  <b-col sm="3" class="pr-0">
                                  <label><b>Status</b></label>&nbsp;<span style="color: red;">*</span>
                                  </b-col>
                                  <b-col sm="9" class="pl-0">
                                  <b-form-group>
                                      <b-form-select
                                      v-model="customer.isactive"
                                      name="status"
                                      v-validate="'required|'"
                                      :class="{
                                          input: true,
                                          'is-invalid': errors.has('form-7.status'),
                                      }"
                                      >
                                      <option :value="selectstatus">--Select--</option>
                                      <option value="1">Active</option>
                                      <option value="0">InActive</option>
                                      </b-form-select>
                  
                                      <b-input-group class="mb-3">
                                      <span class="icon has-text-warning">
                                          <i
                                          class="fa fa-warning help text-danger"
                                          v-show="errors.has('form-7.status')"
                                          >{{ errors.first("form-7.status") }}</i
                                          >
                                      </span>
                                      </b-input-group>
                                  </b-form-group>
                                  </b-col>
                              </b-row>
                              </b-col>
                          </b-row>
                          <hr />
                          <br />
                          <h6><b>Vehicle Info</b></h6>
                  <br />
                  <b-row>
                           <b-col sm="3">
                          <b-form-group>
                              <label for="vehicletypesize">Vehicle Type</label>&nbsp;<span style="color: red;">*</span>
                                  <v-select v-model="customer.vehicletypesize" name="vehicletypesize" :options="vehicleTypeSizeOptions" @input="addVehicleTypeSize" placeholder="-- Select Vehicle Type --" 
                                  v-validate="'required'"
                                  :class="{
                                  input: true,
                                  'is-invalid': errors.has('form-7.vehicletypesize'),
                                  }"></v-select>
                                  <b-input-group class="mb-3">
                                  <span
                                      style="width:240px"
                                      v-show="errors.has('form-7.vehicletypesize')"
                                      class="help text-danger"
                                      >{{
                                      errors.first("form-7.vehicletypesize")
                                      }}</span
                                  >
                                  </b-input-group>                               
                          </b-form-group>
                          
                      </b-col>
                      

                      <b-col sm="3" v-if="vehicletypesizetext">
                          <b-form-group>
                              <label for="vehicle_type_size">Vehicle Type</label>&nbsp;<span style="color: red;">*</span>
                              <b-form-input
                              type="text"
                              name="vehicle_type_size"
                              v-validate="'required|alpha_num'"
                              v-model="customer.vehicletypesizetext"
                              :class="{
                                  input: true,
                                  'is-invalid': errors.has('form-7.vehicle_type_size'),
                              }"
                              placeholder="Enter Vehicle Type"
                              >
                              </b-form-input>
                              <b-input-group class="mb-3">
                              <span class="icon has-text-warning">
                                  <i
                                  class="fa fa-warning"
                                  v-show="errors.has('vehicle_type_size')"
                                  ></i>
                              </span>
                              <span
                                  style="width:240px"
                                  v-show="errors.has('form-7.vehicle_type_size')"
                                  class="help text-danger"
                                  >{{ errors.first("form-7.vehicle_type_size") }}</span
                              >
                              </b-input-group>
                          </b-form-group>
                      </b-col>
                      <b-col sm="3">
                            <b-form-group>
                                <label for="vehicledimensionsweight">Vehicle Dimensions Weight (in fit)</label>&nbsp;<span style="color: red;">*</span>
                                <b-input-group class="mb-3">
                                <b-form-input
                                    class="input"
                                    type="text"
                                    v-model="customer.vehicledimensionsweight"
                                    name="vehicledimensionsweight"
                                    id="vehicledimensionsweight"
                                    v-validate="'required|decimal:3'"
                                    :class="{
                                        input: true,
                                        'is-invalid': errors.has('form-1.vehicledimensionsweight'),
                                        }"
                                    placeholder="Enter Dimensions Weight"
                                >
                                </b-form-input>
                                </b-input-group>
                                <b-input-group class="mb-3">
                                <span
                                    style="width:240px"
                                    v-show="errors.has('form-1.vehicledimensionsweight')"
                                    class="help text-danger"
                                    >{{
                                    errors.first("form-1.vehicledimensionsweight")
                                    }}</span
                                >
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                      
                  </b-row>
                  <hr />
                  <br />

                  
                          <h6 style="text-align:center">
                              <b>Update Transporter Info</b>
                          </h6>
                          <br />
                          <b-row>
                              <b-col sm="4">
                              <b-row>
                                  <b-col sm="5" class="pr-0">
                                  <label><b>Company Name</b></label>&nbsp;<span style="color: red;">*</span>
                                  </b-col>
                                  <b-col sm="7" class="pl-0">
                                  <b-form-group>
                                      <v-select v-model="transporterCompanyName" :options="optionmailid" @input="updateTextbox" placeholder="-- Select Company --" :class="{
                                              input: true,
                                              'is-invalid': errors.has('form-1.companyname'),
                                          }"></v-select>
                                      <span
                                          v-show="errors.has('form-1.companyname')"
                                          class="help text-danger"
                                          >{{ errors.first("form-1.companyname") }}</span
                                          >
                                  </b-form-group>
                                  </b-col>
                              </b-row>
                              </b-col>
                              <b-col sm="4">
                              <b-form-group label="Transporter Name" :label-cols="4">
                                  <b-form-input
                                  class="input"
                                  type="text"
                                  v-model="customer.driver_contracter_name"
                                  name="driver_contracter_name"
                                  v-validate="'required|alpha_spaces'"
                                  placeholder="Enter Driver Transporter Name"
                                  disabled>
                                  </b-form-input>
                                  <!-- <span
                                  style="width:100px"
                                  v-show="errors.has('form-5.driver_contracter_name')"
                                  class="help text-danger"
                                  >{{ errors.first("form-5.driver_contracter_name") }}</span
                                  > -->
                              </b-form-group>
                              </b-col>
                              <b-col sm="4">
                              <b-form-group label="Mobile No" :label-cols="4">
                                  <b-form-input
                                  class="input"
                                  type="text"
                                  id="contractormobilenumber"
                                  name="mobilenumber"
                                  maxlength="10"
                                  v-model="customer.contractormobilenumber"
                                  placeholder="Enter Mobile Number" disabled>
                                  </b-form-input>
                                  <!-- v-validate="'required|digits:10'"
                                  :class="{
                                      input: true,
                                      'text-danger': errors.has('form-5.mobilenumber'),
                                  }" -->
                                  <!-- <span
                                  style="width:100px"
                                  v-show="errors.has('form-5.mobilenumber')"
                                  class="help text-danger"
                                  >{{ errors.first("form-5.mobilenumber") }}</span
                                  > -->
                              </b-form-group>
                              </b-col>
                              <b-col sm="4">
                              <b-form-group label="Email ID" :label-cols="4" disabled>
                                  <b-form-input
                                  class="input"
                                  type="text"
                                  v-model="customer.contracter_emailid"
                                  name="contracter_emailid"
                                  v-validate="'required|email'"
                                  placeholder="Enter Transporter Email ID" disabled
                                  >
                                  </b-form-input>
                                  <!-- <span
                                  style="width:100px"
                                  v-show="errors.has('form-5.contracter_emailid')"
                                  class="help text-danger"
                                  >{{ errors.first("form-5.contracter_emailid") }}</span
                                  > -->
                              </b-form-group>
                              </b-col>
                              <b-col sm="4">
                              <b-form-group label="Tin Number / GST Number" :label-cols="4">
                                  <b-form-input
                                  name="GST Number" type="text"
                                  v-model="customer.transporter_gstnumber" @input="checkGSTlength(customer.transporter_gstnumber)" 
                                  placeholder="Enter Tin Number / GST Number"
                                  :class="{ input: true, 'is-invalid': errors_GST,
                                  }">
                                  </b-form-input>
                                  <b-input-group class="mb-3">
                                  <span class="icon has-text-warning" v-if="errors_GST">
                                          <i
                                          class="fa fa-warning help text-danger"
                                          >{{ errors_showGST.transporter_gstnumber }}</i
                                          >
                                      </span>
                                  </b-input-group>
                              </b-form-group>
                              </b-col>
                              <b-col sm="4">
                              <button type="button" class="btn btn-outline-success btn-md" v-if="showverifybutton" @click="verifyGSTNo()">Verify</button>&nbsp;
                              <button type="button" class="btn btn-outline-danger btn-md" v-if="removeGST" @click="removevalue()">X</button>
                              </b-col>
                          </b-row>
                          <hr />
                          <br />


<h6 v-if="vehicle_historylog.length > 0" style="text-align:center"><b>Vehicle Details Change History</b></h6>

<div class="col-md-12 px-0 mt-2 ml-0 d-block"  v-if="vehicle_historylog.length > 0">
<table class="table table-bordered table-hover">
 <thead>
   <tr>
       <th>Vehicle Updated From</th>
       <th>Vehicle Updated To</th>
       <th>Vehicle Updated On</th>
       <th>Vehicle Updated By</th>
       <th>Comment</th>


   </tr>
</thead> 
<tbody v-if="vehicle_historylog.length > 0">
 <tr v-for="(data,key) in vehicle_historylog">
      <td>{{data.updated_from == 'adhoc' ? data.updated_from : 'Regular' }}</td>
      <td>{{data.updated_to == 'adhoc' ? data.updated_to : 'Regular'}}</td>
       <td>{{ data.vehicle_updated_on | ConvertTime12hour() }}</td>
       <td>{{data.vehicle_updated_by}}</td>
        <td>{{ data.changecomment }}</td>
   </tr>
</tbody>
</table>
</div>

<hr v-if="vehicle_historylog.length > 0" />
 <br>                         
                          </div>
                          <footer
                          class="column text-right"
                          v-if="vehicletype == 'adhoc_vehicle'"
                          >
                          <b-button variant="primary" size="sm" type="submit" id="submitButton"
                              >Update </b-button
                          >&nbsp;
                          <b-button size="sm" variant="danger" @click="editcancel()"
                              >cancel</b-button
                          >
                          </footer>
                      </b-form>

                      </template>
                      <template slot="modal-footer" slot-scope="{ hide }">
                      <b-button size="sm" style="display:none">
                          Cancel
                      </b-button>
                      </template>
                  </b-modal>
                  
                      <!-- change password -->
    <b-modal
      title="Change Password"
      size="md"
      v-model="resetPassword"
      @ok="resetPassword = false"
      hide-footer
    >
      <template slot="default" slot-scope="{ hide }">
        <form @submit.prevent="validateForm4('form-4')" data-vv-scope="form-4">
          <div class="modal-background"></div>
          <div class="modal-card">
            <section class="modal-card-body">
              <div class="field">
                <p class="control">
                  <span style="color: red;"
                    >Strong Passowrd Rules:<br />

                    1)Your password must be between 6 to 14 character<br />
                    2)Password must contain at least one lowercase and uppercase
                    character<br />
                    3)Password must contain at least one number<br />
                    4)Password must contain at least one special character
                    <br />
                  </span>
                  <b-form-input
                    class="input"
                    type="text"
                    name="password"
                    minlength="6"
                    maxlength="14"
                    v-model="deliveryagentpassword"
                    v-validate="{
                      required: true,
                      regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{6,12})/,
                    }"
                    :class="{
                      input: true,
                      'text-danger': errors.has('form-4.password'),
                    }"
                    placeholder="Enter password"
                  />
                  <code
                    v-show="errors.has('form-4.password')"
                    class="help text-danger"
                    >{{ errors.first("form-4.password") }}</code
                  >
                </p>
              </div>
            </section>
            <footer class="text-right">
              <div id="overlayModal">
                <div class="loaderModal"></div>
              </div>
              <b-button size="sm" variant="primary" type="submit" class="mr-4"
                >Update</b-button
              >
              <b-button size="sm" variant="danger" @click="cancelPassword()">
                Cancel
              </b-button>
            </footer>
          </div>
        </form>
      </template>
      <template slot="modal-footer" slot-scope="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button
          size="sm"
          variant="danger"
          @click="cancel()"
          style="display:none"
        >
          Cancel
        </b-button>
        <!-- Button with custom close trigger value -->
      </template>
    </b-modal>

                  <!-- Confirmation Box -->
                  <b-modal 
                  title="Confirmation Box" v-model="toggleInfo" size="md"  @ok="toggleInfo =false"
                  >
                    <template slot="modal-header" slot-scope="{ close }">
                      <h5>Confirmation Box</h5>
                    </template>
                    <template slot="default" slot-scope="{ hide }">
                      <form v-on:submit.prevent="activateInActivateDeliveryAgent(value)">
                        <div class="modal-background"></div>
                        <div class="modal-card">
                          <section class="modal-card-body">
                            <input
                              type="hidden"
                              v-model="customer.isactive"
                              name="isactive"
                              id="modalIsActiveChk"
                            />
                            <span>Are you sure you want to change the status?</span>
                          </section>
                          <footer>
                            <b-button variant="primary" size="sm" type="submit">Ok</b-button>
                          </footer>
                        </div>
                      </form>
                    </template>
                    <template slot="modal-footer" slot-scope="{ cancel }">
                      <!-- Emulate built in modal footer ok and cancel button actions -->
                      <b-button size="sm" variant="danger" @click="cancel()">
                        Cancel
                      </b-button>
                    </template>
                  </b-modal>

              </b-col>
          </b-row>
      </div>
  </Adhoc_regularvehicle-components>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import auth from "@/utils/auth";
import Vue from "vue";
export default {
data: function() {
  return {
    name: "deliveryagentmaster",
    selectstatus :'',
    isBusy: false,

    customer: {},
    // selected:'',
    seen: true,
    searchObj: {},
    editAgentMastertoggleInfo: false,
    editAgentMaster: false,
    toggleInfo: false,

    bordered: true,
    items: [],
    searchResults: [],

    searchResults1: [],

    fields: [
      {
        key: "vehicle_id",
        label: "Vehicle Id",
        sortable: true,
        sortDirection: "desc",
      },
      { key: 'vehicle_origin_city', label: 'Vehicle Origin City', sortable: true, sortDirection: 'desc' },
      // { key: 'drivername', label: 'Driver Name', sortable: true, sortDirection: 'desc' },
      //  { key: 'drivermobilenumber', label: 'Driver Mobile No', sortable: true, sortDirection: 'desc' },
      { key: "vehicle_name", label: "Vehicle Name", sortable: true },

      { key: "fullvehicleno", label: "Vehicle Number", sortable: true },
      { key: "registration_no", label: "Registration No", sortable: true },
      { key: "vehicle_type", label: "Movement Type", sortable: true },
        { key: "vehicle_type_text", label: "Vehicle Type", sortable: true },
      { key: "fueltype", label: "Fuel Type", sortable: true },

      { key: 'isactive', label: 'Isactive', sortable: true},
      // { key: 'vehiclephysicalweight', label: 'Physical Weight', sortable: true},
      { key: "createddate", label: "Created Date", sortable: true },

      { key: "actions", label: "Actions", class: "masterAction" },
    ],
    userType: "",

    totalRows: 0,
   //pagination

   noofpages:'',
      pageNum:1,
      listingpageno:1,
      currentPage: 1,
      perPage:20,

    pageOptions: [5, 10, 15],
    sortBy: null,
    sortDesc: true,
    sortDirection: "desc",
    filter: null,
    vehicleCityWHmodal: false,
    cityData: [],
    adminData: [],
    userType: "",
    showSelectAll: true,
    valueAdmin: [],
    optionsAdmin: [],
    adminSysid: [],
    sysIdinlist: "",
    fieldAdmin: { text: "name", value: "id" },
    vehicle_Id: "",
    sysIdinlist: "",
    SelectVehicletype: "",
    vehicletype: "adhoc_vehicle",
    selected_type: "",
    options: [
      { text: "Adhoc Vehicle", value: "adhoc_vehicle" },
      { text: "Regular Vehicle", value: "regular_vehicle" },
    ],
    sendadminid : [],
    adminWHid: [],
    warehouseData: [],
    warehouseAdmin: [],
    valueWHAdmin :[],
    fieldwhAdmin: { text: "name_wh", value: "id_wh" },
    WHid :'',
    helper_data :[],
    transporter_id:null,
    mailitems :[],
    optionmailid :[],
    transporterCompanyName:null,
    errors_GST:false,
    errors_showGST:{},
    removeGST:false,
    showverifybutton : false,
    driver_data:[],
    toggleInfo:false,
    // adhocerrors_GST:false,
    // adhocerrors_showGST:{},
    // adhocremoveGST:false,
    // adhocshowverifybutton : false,
    vehicleNameOptions:[],
    vehicleTypeSizeOptions:[],
    fuelTypeOptions:[],
    vehiclenametext:false,
    vehicletypesizetext:false,

    vehicleName_id:null,
    vehicleTypeSize_id:null,
    fuelType_id:null,
    resetPassword: false,
    deliveryagentpassword:null,
    ovehicle_id:null,
    getfullname:null,
    oldvehicledata:{},
    regularkeyMap: {
  "vehiclename": "Vehicle Name",
  "vehiclenametext": "Vehicle Name",
  "editvehicleno": "Vehicle Number",
  "registration_no": "Registration No",
  "vehicletype": "Movement Type",
  "vehicletypesize": "Vehicle Type",
  //"vehicletypesizetext": "Vehicle Type",
  "vehicleweightcarrying": "Vol Weight",
  "vehiclephysicalweight": "Phy Weight",
  "vehicledimensionsweight": "Dimensions Weight",
  "fueltype": "Fuel Type",
  "driverfirstname": "Driver First Name",
  "driverlastname": "Driver Last Name",
  "mobile_no": "Driver Mobile No",
  "altmobile_no": "Driver Alt Mobile No",
  "driving_license": "Driving License",
  "helperfirstname": "Helper First Name",
  "helperlastname": "Helper Last Name",
  "helpermobilenumber": "Helper Mobile no",
  "helperaltmobilenumber": "Helper Alt Mobile no",
  "transporterCompanyName": "Transporter Company Name",
  "driver_contracter_name": "Transporter Name",
  "contractormobilenumber": "Transporter Mobile No",
  "contracter_emailid": "Transporter Email ID",
  "transporter_gstnumber": "Transporter Tin Number / GST Number",
  "isactive": "Driver Status",
  "oadmin":"select admin",
  "ocity":"select city",
  "drivermobilenumber":"Driver Mobile No"
      },
      vehicle_historylog:[],
      getmyvehicleid:null,
      accessBody:[],
      isReadOnly:false,
  };
},
created: function() {
  var userdata = localStorage.getItem("userData");
  var userInfo = JSON.parse(userdata);
  this.userType = userInfo.user_type;
  console.log("YYUUUU", this.userType);
  this.user_id = userInfo.sysusermasterid;
  let firstname = userInfo.userfirstname ? userInfo.userfirstname : ''
    let lastname = userInfo.userlastname ? userInfo.userlastname : ''
     this.getfullname = firstname +" "+ lastname;

     this.accessBody = userInfo.body;
    console.log("--------->>>>>>>>>>",userInfo.body)
    this.ischeckbodyvalidation();

    this.pageNum=1;
    this.displaydata(this.pageNum);
  this.getVehicleDetailsList();
},
computed: {
  sortOptions() {
    // Create an options list from our fields
    return this.fields
      .filter((f) => f.sortable)
      .map((f) => {
        return { text: f.label, value: f.key };
      });
  },
},
methods: {
  Clearsearch(){
      this.searchfilter='';
      this.pageNum=1;
      this.displaydata(this.pageNum);
    },
  ischeckbodyvalidation(){
            for (let i = 0; i < this.accessBody.length; i++) {
                const element = this.accessBody[i];
            
                // if (element.title=='Adhoc Vehicle' && element.isReadonly==true && this.route_id=='normal') {
                //   this.isReadOnly=true
                // }
            if (element.child) {
                for (let j = 0; j < element.child.length; j++) {
                const k = element.child[j];
                if (k.title=='Adhoc Vehicle' && k.isReadonly==true) {
                    this.isReadOnly=true
                }
                }
            }
            }
            console.log(" this.isReadOnly", this.isReadOnly)
        },
  downloadadhocreport(){
    document.getElementById("overlay").style.display = "block";
     var userdata = localStorage.getItem('userData')
    var userInfo = JSON.parse(userdata)
        var csvObj = {
          sysusermasterid:`${userInfo.sysusermasterid}`,
          usertype:`${userInfo.user_type}`,
         };
         // console.log("JJJJJ",csvObj);
      // console.log("csvObj",csvObj);
      this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getCSVForAdhocVehicle`, csvObj)
        .then(result => {
        document.getElementById("overlay").style.display = "none";
         if(result.body=="success")
       {
       // alert("Please Check Ur Mail For Downlod Link")
       this.$fire({
                text:"Please Check Your Mail For Downlod Link",
                type: "success",
                timer: 30000
              }); 
     }
     else
     {
      this.$fire({
                text:"Can not Download",
                type: "error",
                timer: 30000
              }); 
     }

        })
        .catch(ex => {
          console.log("error-----", ex);
        });
  },

  clickCallback (pageNum){
      this.displaydata(pageNum);
    },

  displaydata: function(pageNo) {
    // alert("innnn");
    this.items = [];
    this.totalRows =0;
    this.isBusy = true;
    var userdata = localStorage.getItem("userData");
    var userInfo = JSON.parse(userdata);
    const adhocVehicleobj = {
      sysusermasterid: `${userInfo.sysusermasterid}`,
      usertype: `${userInfo.user_type}`,
      page_no: `${pageNo}`,
      pageSize:20,
      vehiclefilter:this.searchfilter

    };
    console.log("deliveryagentobj", adhocVehicleobj);
    this.$http
      .post(
        `${CONSTANTS.MIGRATION_API_URL}/getAllAdhocVehicleListing`,
        adhocVehicleobj
      )
      .then((result) => {
        console.log("YYY", result);
        this.isBusy = false;
        if (result.body.returnmsg == "Successfull") {
          // this.data = result.body;

          this.items = result.body.returnvalue;

          this.totalRows = result.body.totalcount;
          console.log("RRRR", this.totalRows);
          this.noofpages=parseInt(this.totalRows)/20;
          this.noofpages=Math.ceil( this.noofpages);
        } else {
          // this.isBusy = false;
          // this.data = result.body;
          this.items = result.body.returnvalue;
          this.totalRows = 0;
        }
      })
      .catch((ex) => {
        console.log("error", ex);
      });
  },

  getVehicleDetailsList:function(){
     var userdata = localStorage.getItem("userData");
    var userInfo = JSON.parse(userdata);

    const Obj={

    }

    this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getVehicleDetailsList`, Obj)
    .then((result)=>{
      if(result.body && result.body.returnmsg== "Successful"){
        var vehicleNameData=result.body.returnvalue[0].vehicle_name;
        var vehicleTypeSizeData=result.body.returnvalue[0].vehicle_type;
        var fuelTypeData=result.body.returnvalue[0].fuel_Type;
                  
        for(let i=0;i<vehicleNameData.length;++i){
          this.vehicleNameOptions.push({
            key:vehicleNameData[i].id,
            label:vehicleNameData[i].value
          })
          if(i==vehicleNameData.length-1){
            this.vehicleNameOptions.push({
              label:'Other'
           })
          }
        }  
        console.log("vehicle Name Options-->",this.vehicleNameOptions)              

        for(let i=0;i<vehicleTypeSizeData.length;++i){
          this.vehicleTypeSizeOptions.push({
            key:vehicleTypeSizeData[i].id,
            label:vehicleTypeSizeData[i].value
          })
          if(i==vehicleTypeSizeData.length-1){
            this.vehicleTypeSizeOptions.push({
              key:'00',
              label:'Other'
            })
          }
        }
        console.log("vehicle Type Size Options-->",this.vehicleTypeSizeOptions) 

        for(let i=0;i<fuelTypeData.length;++i){
          this.fuelTypeOptions.push({
            key:fuelTypeData[i].id,
            label:fuelTypeData[i].value
          })
        }
        console.log("fuel Type Options-->",this.fuelTypeOptions)
      }
      else{
        this.vehicleNameOptions=[];
        this.vehicleTypeSizeOptions=[];
        this.fuelTypeOptions=[];
      }
    })
    .catch((ex) => {
      console.log("error", ex);
    });
  },

  addVehicleName:function(){
    this.customer.vehiclenametext='';
    if(this.customer.vehiclename.label=='Other'){
      this.vehiclenametext=true;
    }
    else{
      this.vehiclenametext=false;
    }
  },

  addVehicleTypeSize:function(){
    this.customer.vehicletypesizetext='';
    if(this.customer.vehicletypesize.label=='Other'){
      this.vehicletypesizetext=true;
    }
    else{
      this.vehicletypesizetext=false;
    }
  },

  editcancel: function() {
    this.customer = {};
    this.vehicletype = "adhoc_vehicle";
    console.log("oooo", this.vehicletype);
    this.editAgentMaster = !this.editAgentMaster;
  },

  editinfoModal: function(value) {
    this.vehiclenametext=false;
    this.vehicletypesizetext=false;
    this.EmailListing();
    this.helper_data=[];
    this.customer={};
    this.showverifybutton=false;
      this.errors_GST = false;
      this.errors_showGST= {};
      this.removeGST=false;
    this.vehicletype = "adhoc_vehicle";
    console.log("oooo", value);
    this.customer.isactive = value.isactive;
    this.customer.driverfirstname = value.driverfirstname;
    this.customer.driverlastname = value.driverlastname;
    this.customer.drivermobilenumber = value.drivermobilenumber;
    // this.customer.vehicleno_prefix = value.vehicleno_prefix;
    //this.customer.vehiclename = value.vehicle_name;
    this.customer.vehicletype = "";
    this.customer.registration_no = value.registration_no;
     if(value.vehicletypesize == null)
     {
      this.vehicletypesizetext = true;
      this.customer.vehicletypesize='Other';
     }else{
      this.customer.vehicletypesize=value.vehicletypesize;
     }

     this.customer.vehicletypesizetext=value.vehicletypesizetext;
    // console.log("Make Type", this.customer.vehicletype);
    // this.customer.vehiclemake = value.vehicle_make;
    this.customer.vehicleweightcarrying = value.vehicleweightcarrying;
    this.customer.vehiclephysicalweight = value.vehiclephysicalweight;
    this.customer.vehicledimensionsweight = value.vehicledimensionsweight;
    this.customer.editvehicleno = value.fullvehicleno;
    this.customer.fueltype = value.fueltype;
    this.fuelType_id = value.fueltype_id;
    this.customer.vehicleMasterid = value.vehicle_id;

    this.customer.mobile_no = value.drivermobilenumber;
    this.customer.altmobile_no = value.driveraltmobilenumber;

    this.customer.helperfirstname = value.helperfirstname;
    this.customer.helperlastname = value.helperlastname;
    this.customer.helpermobilenumber = value.helpermobilenumber;
    this.customer.helperaltmobilenumber = value.helperaltmobilenumber;
    this.customer.contractormobilenumber = value.contractormobilenumber;

    this.customer.driving_license = value.driving_license;
    this.customer.driver_contracter_name = value.drivercontractername;
    this.customer.contracter_emailid = value.contracter_emailid;
    this.customer.transporter_gstnumber = value.transporter_gst_no;
    this.transporter_id = value.transporter_id;
    this.transporterCompanyName=value.drivercontractername != null ? value.transporter_company_name :'';
    if (this.userType==2) {
          this.editWiseWarehouseList()
      }
      this.customer.vehicletype = 'adhoc'
      let oldpayloaddata = {}
      oldpayloaddata.driverfirstname = value.driverfirstname;
      oldpayloaddata.driverlastname = value.driverlastname;
      oldpayloaddata.drivermobilenumber = value.drivermobilenumber;
     // oldpayloaddata.vehiclename = value.vehicle_name;
      oldpayloaddata.vehicletype = 'adhoc';  
      oldpayloaddata.fueltype = value.fueltype;
      oldpayloaddata.vehicletypesize = value.vehicletypesize ? value.vehicletypesize: 'Other';
      oldpayloaddata.registration_no = value.registration_no;
      oldpayloaddata.vehicleweightcarrying = value.vehicleweightcarrying;
      oldpayloaddata.vehiclephysicalweight = value.vehiclephysicalweight;
      oldpayloaddata.vehicledimensionsweight = value.vehicledimensionsweight;
      oldpayloaddata.editvehicleno = value.fullvehicleno;
      oldpayloaddata.isactive = value.isactive;
      oldpayloaddata.mobile_no = value.drivermobilenumber;
      oldpayloaddata.altmobile_no = value.driveraltmobilenumber;
      oldpayloaddata.helperfirstname = value.helperfirstname;
      oldpayloaddata.helperlastname = value.helperlastname;
      oldpayloaddata.helpermobilenumber = value.helpermobilenumber;
      oldpayloaddata.contractormobilenumber = value.contractormobilenumber;
      oldpayloaddata.driver_contracter_name = value.drivercontractername
      oldpayloaddata.transporter_gstnumber = value.transporter_gst_no;
      oldpayloaddata.transporterCompanyName = value.drivercontractername != null ? value.transporter_company_name : '';
      // oldpayloaddata.driving_license = value.driving_license;
      oldpayloaddata.contracter_emailid = value.contracter_emailid
      oldpayloaddata.helperaltmobilenumber = value.helperaltmobilenumber;
      oldpayloaddata.driving_license = value.driving_license;
      oldpayloaddata.drivermobilenumber = value.drivermobilenumber

     // oldpayloaddata.whadmindata = value.warehouseid ? value.warehouseid : ''

      this.oldvehicledata = oldpayloaddata
      
      

      this.getmyvehicleid = this.customer.vehicleMasterid
      this.VehicleListingLog(this.customer.vehicleMasterid)


    this.editAgentMaster = !this.editAgentMaster;
  },

  editvehicleCityWH: function(value) {
    console.log("Value===========",value);
    // document.getElementById("overlayModal").style.display = "block";
    var userdata = localStorage.getItem("userData");
    var userInfo = JSON.parse(userdata);
    this.valueAdmin = [];
    this.optionsAdmin = [];
    this.warehouseData = [];
      this.warehouseAdmin = [];
      this.valueWHAdmin = [];
      this.valueWHAdmin=[];
    this.vehicle_Id = value.vehicle_id;
    this.sysIdinlist = value.sysusermasterid;

    this.WHid = value.warehouseid;
    // console.log("this.vehicle_Id=value.vehicle_id;",this.sysIdinlist);
    this.vehicle_Id = value.vehicle_id;

    if (this.WHid !=null) {
      this.adminWHid = this.WHid.split(",");
      this.oldvehicledata.ocity = this.WHid
      console.log("YYYYYYYYYY", this.adminWHid);
      for (let i = 0; i < this.adminWHid.length; i++) {
        this.valueWHAdmin.push(this.adminWHid[i]);
      }
      console.log("this.valueWHAdmin",this.valueWHAdmin)
    }
    console.log("this.sysIdinlist",this.sysIdinlist)

    if (this.sysIdinlist != null) {
      this.adminSysid = value.sysusermasterid.split(",");
      this.oldvehicledata.oadmin = value.sysusermasterid
      // console.log("YYYYYYYYYY", this.adminSysid);
      for (let i = 0; i < this.adminSysid.length; i++) {
        this.valueAdmin.push(this.adminSysid[i]);
      }
    }

    const Obj = {
      sysusermasterid: `${userInfo.sysusermasterid}`,
      usertype: `${userInfo.user_type}`,
    };
    console.log("Obj", Obj);
    this.$http
      .post(`${CONSTANTS.MIGRATION_API_URL}/adminListingForVehicle`, Obj)
      .then((result) => {
        console.log("YYY", result);
        // document.getElementById("overlayModal").style.display = "none";
        if (result.body.returnmsg === "Successful") {
          this.adminData = result.body.returnvalue;
          for (let i = 0; i < this.adminData.length; i++) {
            let admin = {
              name:
                this.adminData[i].userfirstname +
                "" +
                this.adminData[i].userlastname +
                " - " +
                (this.adminData[i].user_type == 2 ? "Admin" : "Super Admin"),
              id: this.adminData[i].sysusermasterid.toString(),
            };

            this.optionsAdmin.push(admin);
            // console.log("HHHHAAAA",this.optionsAdmin);
          }
          // console.log(this.optionsAdmin);
        } else {
          this.adminData = result.body.returnvalue;
        }
      })
      .catch((ex) => {
        console.log("error", ex);
      });
  },
  
  selectAdmin: function() {
    this.valueAdmin;
    this.valueAdmin.toString();
    console.log("999999999999999999999999999999999999",this.valueAdmin)
    this.editWiseWarehouseList();
         
  },

  isJson: function(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  },

  editWiseWarehouseList: function() {
    if (this.userType==2) {
              this.valueAdmin.push(this.user_id)
          }

    this.sendadminid = this.valueAdmin.toString().split(",");

    if (this.valueAdmin.length>0) {
      
      const Obj = {
        sysusermasterid:  this.sendadminid,
      };
      console.log("Obj", Obj);
      
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getAdminWiseWarehouseList`, Obj)
      .then((result) => {
        console.log("result",result)
        if (result.body.returnmsg === "Successful") {
          this.warehouseAdmin = [];
          this.warehouseData = result.body.returnvalue;
          // console.log("oooooooooooooooooooooooooooooooooooooooooooooooo")
          for (let i = 0; i < this.warehouseData.length; i++) {
            // console.log("oooooooooooooooooooooooooooooooooooooooooooooooo")
            let whadmin = {
              name_wh: this.warehouseData[i].city + ' - ' + this.warehouseData[i].warehousename,
              id_wh: this.warehouseData[i].warehouseid,
            };
            this.warehouseAdmin.push(whadmin);
            // console.log("warehouseAdmin",this.warehouseAdmin)
          }
        }
      })
      .catch((ex) => {
        console.log("error", ex);
      });
    } 
    else{
      this.warehouseData = [];
      this.warehouseAdmin = [];
      this.valueWHAdmin = [];
    }
  },

  selectWHAdmin: function() {
      var systemUserid = [];
      this.valueWHAdmin;
      this.valueWHAdmin.toString();
  },

  ///regular 
  validateForm5(scope) {
    this.$validator.validateAll(scope).then((result) => {
      if (result) {
        this.updateDeliveryAgent();
      }
    });
  },

  updateDeliveryAgent: function() {
    document.getElementById("overlayModal").style.display = "block";
    var result = [];
    // alert("innnn");
    var userdata = localStorage.getItem("userData");
    var userInfo = JSON.parse(userdata);

    if (this.customer.altmobile_no == this.customer.mobile_no) {
      // alert("Alternate Mobile Number should be different from Mobile Number");
      this.$fire({
        text:
          "For Driver Alternate Mobile Number should be different from Mobile Number",
        type: "warning",
        timer: 30000,
      });
      document.getElementById("overlayModal").style.display = "none";
      return false;
    }

    if ( this.customer.helperaltmobilenumber == this.customer.helpermobilenumber ) {
      // alert("Alternate Mobile Number should be different from Mobile Number");
      this.$fire({
        text:
          "For Helper Alternate Mobile Number should be different from Mobile Number",
        type: "warning",
        timer: 30000,
      });
      document.getElementById("overlayModal").style.display = "none";
      return false;
    }

    if (this.valueAdmin.length > 0) {
        var systemUserid = [];
        systemUserid = this.valueAdmin.toString().split(",");
    }
    else{
        this.$fire({
          text: "Please Select Admin",
          type: "warning",
          timer: 30000,
        });
        document.getElementById("overlayModal").style.display = "none";
        return false;
    }

    if (this.valueWHAdmin.length > 0) {
        var selctWarehouseid = [];
        selctWarehouseid = this.valueWHAdmin.toString().split(",");
    }
    else{
      this.$fire({
        text: "Please Select City",
        type: "warning",
        timer: 30000,
      });
      document.getElementById("overlayModal").style.display = "none";
      return false;
    }
    console.log("this.transporterCompanyName-------->",this.transporterCompanyName);
    if(this.transporterCompanyName==null){
        document.getElementById("overlayModal").style.display = "none";
        this.$fire({
        text:"Please Select Transporter Company",
        type: "warning",
        timer: 30000,
        });
        return false;  
      }

      if(this.customer.driver_contracter_name == null || this.customer.contractormobilenumber == null || this.customer.contracter_emailid ==null){
        this.$fire({
          text:"Please Add Transporter Details From Transporter Master",
          type: "warning",
          timer: 30000,
        });
        document.getElementById("overlayModal").style.display = "none";
        return; 
      }

      console.log("--------",this.transporter_id,this.transporterCompanyName)
      this.driver_data.push({
        driverfirstname: this.customer.driverfirstname.trim(),
        driverlastname: this.customer.driverlastname.trim(),
        drivermobilenumber: this.customer.mobile_no,
        driveraltmobilenumber: this.customer.altmobile_no,
        driving_license: this.customer.driving_license.trim(),
        driver_license_photo:'',
        driver_license_criteria:'',
        driver_email:'',
        driver_adhar_no:'',
        driver_emergency_no:'',
        driver_adhar_photo:'',
        driver_language:[],
        driver_qualification:[]
      });
      this.helper_data.push({
          helperfirstname: this.customer.helperfirstname.trim(),
          helperlastname: this.customer.helperlastname.trim(),
          helpermobilenumber: this.customer.helpermobilenumber.trim(),
          helperaltmobilenumber: this.customer.helperaltmobilenumber.trim(),
          helper_license_number:"",
          helper_license_photo:"",
          helper_license_criteria:"",
          helper_email:"",
          helper_adhar_no:"",
          helper_adhar_photo:""
        });
      console.log("this.helper_data",this.helper_data);
    //   let newwhadmindata = this.valueWHAdmin && Array.isArray(this.valueWHAdmin) ? this.valueWHAdmin.join(','): ''  
    // this.customer.whadmindata = newwhadmindata

    this.customer.oadmin = this.valueAdmin.join(',')
      this.customer.ocity = this.valueWHAdmin.join(',')

      let ologcommentdata = this.comparePayloadsWithKeyMap(this.oldvehicledata,this.customer,this.regularkeyMap)

 
    var passwObj = {
      adhockpayload: {
        vehicleid: `${this.customer.vehicleMasterid}`,
        vehicleno: this.customer.editvehicleno.trim(),
        fueltype: this.customer.fueltype.key == '' || this.customer.fueltype.key == null || this.customer.fueltype.key == undefined || this.customer.fueltype.key == 'null' || this.customer.fueltype.key == 'undefined' ? this.fuelType_id : this.customer.fueltype.key,
        lastmodifiedby: `${userInfo.sysemailid.trim()}`,
        driverfirstname: this.customer.driverfirstname.trim(),
        driverlastname: this.customer.driverlastname.trim(),
        drivermobilenumber: this.customer.mobile_no.trim(),
        driveraltmobilenumber: this.customer.altmobile_no,
        //vehiclename: this.customer.vehiclename.trim(),
        vehiclename: this.customer.vehiclenametext == false ? this.customer.vehiclename.key : this.customer.vehiclenametext.trim(),
        vehicletypesize: this.vehicletypesizetext==false ? this.customer.vehicletypesize.key:0,
        // this.customer.vehicletypesizetext.trim()
        vehicletypesizetext :this.vehicletypesizetext==true ? this.customer.vehicletypesizetext.trim():'',
        // vehicleno_prefix:`${this.customer.vehicleno_prefix}`,

        helperfirstname: this.customer.helperfirstname.trim(),
        helperlastname: this.customer.helperlastname.trim(),
        helpermobilenumber: this.customer.helpermobilenumber.trim(),
        helperaltmobilenumber: this.customer.helperaltmobilenumber.trim(),
        driving_license: `${this.customer.driving_license.trim()}`,
        // driver_contracter_name:`${this.customer.driver_contracter_name}`,
        contracter_emailid: `${this.customer.contracter_emailid.trim()}`,
        vehicletype: this.customer.vehicletype.trim(),

      
        registration_no: this.customer.registration_no.trim(),
        // vehiclemake: this.customer.vehiclemake.trim(),
        vehicleweightcarrying: this.customer.vehicleweightcarrying.trim(),
        vehiclephysicalweight: this.customer.vehiclephysicalweight.trim(),
        vehicledimensionsweight: this.customer.vehicledimensionsweight.trim(),
        // editvehicleno:this.customer.editvehicleno,
        helper_data:this.helper_data,
        contractormobilenumber: this.customer.contractormobilenumber!=null || this.customer.contractormobilenumber!=undefined || this.customer.contractormobilenumber !=""?this.customer.contractormobilenumber.trim():'',

        // drivercontractername: this.customer.driver_contracter_name.trim(),
        drivercontractername: this.customer.driver_contracter_name!=null || this.customer.driver_contracter_name!=undefined || this.customer.driver_contracter_name !=""?this.customer.driver_contracter_name.trim():'',
        contracter_emailid: this.customer.contracter_emailid!=null || this.customer.contracter_emailid!=undefined || this.customer.contracter_emailid !=""?this.customer.contracter_emailid.trim():'',
        sysusermasterid: systemUserid,
        warehouseid : selctWarehouseid,
        // transporter_id :  this.customer.transporter_id,
        // transporter_id : this.transporter_id?this.transporter_id:this.transporterCompanyName.key,
        transporter_id : this.transporterCompanyName.key=='' || this.transporterCompanyName.key == null || this.transporterCompanyName.key == undefined || this.transporterCompanyName.key == 'null' || this.transporterCompanyName.key == 'undefined' ? this.transporter_id:this.transporterCompanyName.key,
        transporter_company_name:this.transporterCompanyName.label?this.transporterCompanyName.label:this.transporterCompanyName,
        transporter_gstnumber:this.customer.transporter_gstnumber==null||this.customer.transporter_gstnumber==undefined || this.customer.transporter_gstnumber==''?'':this.customer.transporter_gstnumber.trim(),
        driver_data:this.driver_data,
        isactive:this.customer.isactive,
        oldvehicletype:'adhoc',
        logcommentdata:ologcommentdata ? ologcommentdata : "",
        getfullname:this.getfullname
      },
    };
    console.log("Hiiii", passwObj);
    // return false;
    this.$http
      .post(
        `${CONSTANTS.MIGRATION_API_URL}/editAdhocVehicleTypetoInterIntra`,
        passwObj
      )
      .then((result) => {
        document.getElementById("overlayModal").style.display = "none";
        if (result.body.returnmsg === "Successful") {
          // alert("Updated Successfully");
          this.$fire({
            text: "Updated Successfully",
            type: "success",
            timer: 30000,
          });

          this.customer = {};
          this.pageNum=1;
          this.displaydata(this.pageNum);
          
          this.editAgentMaster = !this.editAgentMaster;
          this.$router.push("/vehicleMaster");
        } else {
          // Utils.notify(result.body.returnvalue, "error");
          // alert(result.body.returnvalue);
          // this.$alert(result.body.returnvalue);
          this.$fire({
            text: result.body.returnvalue,
            type: "error",
            timer: 300000,
          });
        }
      })
      .catch((ex) => {
        console.log("error", ex);
      });
  },

  //adhoc
  validateForm7(scope) {
    this.$validator.validateAll(scope).then((result) => {
      if (result) {
        this.updateAdhocDeliveryAgent();
      }
    });
  },

  updateAdhocDeliveryAgent: function() {
    var result = [];
    // alert("innnn");

    //console.log('this.valueWHAdmin======>',this.valueWHAdmin)

    console.log('this.valueAdmin========>',this.valueAdmin)

    document.getElementById("overlayModal").style.display = "block";
    var userdata = localStorage.getItem("userData");
    var userInfo = JSON.parse(userdata);

    console.log('userInfo>>>',userInfo);

console.log('userInfo.user_type',userInfo.userType);
  if(userInfo.userType==1){
   if (this.valueAdmin.length > 0 && userInfo.userType==1) {
        var systemUserid = [];
        systemUserid = this.valueAdmin.toString().split(",");
    }
    else{
        this.$fire({
          text: "Please Select Admin",
          type: "warning",
          timer: 30000,
        });
        document.getElementById("overlayModal").style.display = "none";
        return false;
    }

  }
  else {
  var systemUserid = [];
  systemUserid=this.user_id;
  }
    if (this.valueWHAdmin.length > 0) {
        var selctWarehouseid = [];
        selctWarehouseid = this.valueWHAdmin.toString().split(",");
    }
    else{
      this.$fire({
        text: "Please Select City",
        type: "warning",
        timer: 30000,
      });
      document.getElementById("overlayModal").style.display = "none";
      return false;
    }

    if(this.transporterCompanyName==null){
        
        this.$fire({
        text:"Please Select Transporter Company",
        type: "warning",
        timer: 30000,
        });
        document.getElementById("overlayModal").style.display = "none";
        return false;  
      }

      if(this.customer.driver_contracter_name == null || this.customer.contractormobilenumber == null || this.customer.contracter_emailid ==null){
        this.$fire({
          text:"Please Add Transporter Details From Transporter Master",
          type: "warning",
          timer: 30000,
        });
        document.getElementById("overlayModal").style.display = "none";
        return; 
      }
      console.log("--------",this.transporter_id,this.transporterCompanyName, this.transporterObj)
      this.driver_data.push({
        driverfirstname: this.customer.driverfirstname.trim(),
        driverlastname: this.customer.driverlastname.trim(),
        drivermobilenumber: this.customer.mobile_no,
        driveraltmobilenumber: this.customer.altmobile_no,
        driving_license: this.customer.driving_license.trim(),
        driver_license_photo:'',
        driver_license_criteria:'',
        driver_email:'',
        driver_adhar_no:'',
        driver_emergency_no:'',
        driver_adhar_photo:'',
        driver_language:[],
        driver_qualification:[]
      });
    this.helper_data.push({

      helperfirstname: "",

      helperlastname: "",

      helpermobilenumber: "",

      helperaltmobilenumber: "",

      helper_license_number:"",

      helper_license_photo:"",

      helper_license_criteria:"",

      helper_email:"",

      helper_adhar_no:"",

      helper_adhar_photo:""

    });
    
      this.customer.oadmin = this.valueAdmin.join(',')
      this.customer.ocity = this.valueWHAdmin.join(',')
    //console.log('this.oldvehicledata========>',this.oldvehicledata)
  //console.log('this.customer==========>',this.customer)


    let ologcommentdata = this.comparePayloadsWithKeyMap(this.oldvehicledata,this.customer,this.regularkeyMap)

    var passwObj = {
      adhockpayload: {
        vehicleid: `${this.customer.vehicleMasterid}`,
        vehicleno: this.customer.editvehicleno.trim(),
        fueltype:this.customer.fueltype.key == '' || this.customer.fueltype.key == null || this.customer.fueltype.key == undefined || this.customer.fueltype.key == 'null' || this.customer.fueltype.key == 'undefined' ? this.fuelType_id : this.customer.fueltype.key,
        lastmodifiedby: `${userInfo.sysemailid.trim()}`,
        driverfirstname: this.customer.driverfirstname.trim(),
        driverlastname: this.customer.driverlastname.trim(),
        drivermobilenumber: this.customer.drivermobilenumber.trim(),
        driving_license: `${this.customer.driving_license.trim()}`,
        vehicletype: "adhoc",
        vehicletypesize: this.customer.vehicletypesizetext==false ? this.customer.vehicletypesize.key: 0,
        vehicletypesizetext: this.customer.vehicletypesizetext==false ? this.customer.vehicletypesize.label:this.customer.vehicletypesizetext.trim(),
//vehiclename: this.customer.vehiclename.trim(),
        vehiclename: '',
        helper_data : this.helper_data,
        driver_data : this.driver_data,
        registration_no: this.customer.registration_no.trim(),
        contractormobilenumber: this.customer.contractormobilenumber==null || this.customer.contractormobilenumber==undefined || this.customer.contractormobilenumber == "" ? '' : this.customer.contractormobilenumber.trim(),
        // drivercontractername: this.customer.driver_contracter_name.trim(),
        drivercontractername: this.customer.driver_contracter_name==null || this.customer.driver_contracter_name==undefined || this.customer.driver_contracter_name ==""?'':this.customer.driver_contracter_name.trim(),
        contracter_emailid: this.customer.contracter_emailid==null || this.customer.contracter_emailid==undefined || this.customer.contracter_emailid==""?"":this.customer.contracter_emailid.trim(),
        sysusermasterid: systemUserid,
        warehouseid : selctWarehouseid,
        transporter_id :  this.transporterCompanyName.key=='' || this.transporterCompanyName.key == null || this.transporterCompanyName.key == undefined || this.transporterCompanyName.key == 'null' || this.transporterCompanyName.key == 'undefined' ? this.transporter_id:this.transporterCompanyName.key,
        transporter_company_name:this.transporterCompanyName.label?this.transporterCompanyName.label:this.transporterCompanyName,
        transporter_gstnumber:`${this.customer.transporter_gstnumber==null||this.customer.transporter_gstnumber==undefined?'':this.customer.transporter_gstnumber.trim()}`,
        isactive:this.customer.isactive,
        oldvehicletype: "adhoc",
        logcommentdata:ologcommentdata ? ologcommentdata : "",
        getfullname:this.getfullname,
        vehicledimensionsweight: this.customer.vehicledimensionsweight.trim()
      },
    };
    console.log("Hiiii", passwObj);
    // return false;
    this.$http
      .post(
        `${CONSTANTS.MIGRATION_API_URL}/editAdhocVehicleTypetoInterIntra`,
        passwObj
      )
      .then((result) => {
        document.getElementById("overlayModal").style.display = "none";
        if (result.body.returnmsg === "Successful") {
          // alert("Updated Successfully");
          this.$fire({
            text: "Updated Successfully",
            type: "success",
            timer: 30000,
          });

          this.customer = {};
          this.pageNum=1;
          this.displaydata(this.pageNum);
          this.editAgentMaster = !this.editAgentMaster;
          this.vehicleNameOptions=[];
          this.vehicleTypeSizeOptions=[];
          this.fuelTypeOptions=[];
          this.getVehicleDetailsList();
        } else {
          this.$fire({
            text: result.body.returnvalue,
            type: "error",
            timer: 300000,
          });
        }
      })
      .catch((ex) => {
        console.log("error", ex);
      });
  },

  checkGSTlength(value){
    if (value.length>0) {
        this.showverifybutton=true;
        document.getElementById("submitButton").disabled = true; 
      }
    else{
      this.showverifybutton=false;
      this.customer.transporter_gstnumber='';
      this.errors_GST = false;
      this.errors_showGST= {};
      document.getElementById("submitButton").disabled = false;
      this.removeGST=false;
    }
  },

  verifyGSTNo(){
    document.getElementById("overlayModal").style.display = "block";
    const infoObj = {
      Gstin:this.customer.transporter_gstnumber.trim(),
    };
    console.log("infoObj",infoObj);
    this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/validateGSTNO`, infoObj).then((result)=>{
      console.log("result",result)
      document.getElementById("overlayModal").style.display = "none";
      if (result.body === "success") {
        document.getElementById("submitButton").disabled = false;
        this.showverifybutton=false;
        this.$fire({
          text: 'Successful Verify',
          type: "success",
          timer: 30000,
        });
        this.errors_GST = false;
        this.errors_showGST.transporter_gstnumber=''
        this.removeGST=false;
      } else {
        this.errors_GST = true;
        this.errors_showGST.transporter_gstnumber = 'Please Enter Valid Transporter Tin Number / GST Number';
        this.removeGST=true;
      }
    }).catch((ex) => {
      console.log("error", ex);
    });
    // if (this.customer.transporter_gstnumber) {
    //     this.errors_GST = true;
    //     this.errors_showGST.transporter_gstnumber = 'Please Enter Valid Transporter Tin Number / GST Number';
    //     this.removeGST=true;
    //     return false;
    // }
    // else{
    //   this.showverifybutton=false;
    //   document.getElementById("submitButton").disabled = false;
    // }
  },

  removevalue(){
    this.showverifybutton=false;
    this.customer.transporter_gstnumber='';
    this.errors_GST = false;
    this.errors_showGST= {};
    document.getElementById("submitButton").disabled = false;
    this.removeGST=false;
  },

  EmailListing(){
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);

        // let obj = { }
        let obj = {
                status : 'Approved'
             }
        this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getTransporterEmailIdList`,obj)
        .then(result => {
            if(result.body.returnmsg === "Successful"){
            this.mailitems  = result.body.returnvalue;
            console.log("mailitems",this.mailitems);
            var data = [];

            this.mailitems.forEach(function (srData) {
                data.push({
                key:srData.transporter_id,
                label:srData.transporter_company_name
                });
            });
            this.optionmailid = data;

            }
            else{
              this.mailitems=[];
              this.optionmailid = [];
            }

        }).catch(ex => {
          console.log('error', ex)
        })
  },

  updateTextbox() {
          let transporterObj={};
          if(this.transporterCompanyName!=null){
              for(let i=0;i<this.mailitems.length;i++){
              if(this.transporterCompanyName.key===this.mailitems[i].transporter_id){
                  transporterObj={
                      transporter_id:this.mailitems[i].transporter_id,
                      transporter_name:this.mailitems[i].transporter_name,
                      transporter_emailid:this.mailitems[i].transporter_emailid,
                      transporter_mobilenumber:this.mailitems[i].transporter_mobilenumber,
                      // transporter_gstnumber:this.mailitems[i].transporter_gst_no
                      transporter_gstnumber:this.mailitems[i].transporter_gst_no == undefined || this.mailitems[i].transporter_gst_no == 'undefined' ? '' : this.mailitems[i].transporter_gst_no
                  }
              }
          }
          this.transporterObj=transporterObj;
          console.log("this.transporterObj",this.transporterObj);
          this.updateData(transporterObj);
          }
  },
  
  updateData(transporterObj){
          // this.transporterCompanyName=
          this.customer.contracter_emailid=transporterObj.transporter_emailid;
          this.customer.driver_contracter_name=transporterObj.transporter_name;
          this.customer.contractormobilenumber=transporterObj.transporter_mobilenumber;
          this.customer.transporter_gstnumber=transporterObj.transporter_gstnumber;
  },
  toggleInfoModal: function(value) {
    this.customer = value;

    this.toggleInfo = !this.toggleInfo;
  },

  activateInActivateDeliveryAgent: function(value) {
    var activeInactiveVal;
    if (this.customer.isactive === "1") {
      activeInactiveVal = "0";
      // console.log("activeInactiveVal",activeInactiveVal);
    } else {
      activeInactiveVal = "1";
      // console.log("activeInactiveVal1",activeInactiveVal);
    }
    var userdata = localStorage.getItem("userData");
    var userInfo = JSON.parse(userdata);
    const customerGetobj = {
      // deliveryagentmasterid: deliveryagentmasterId,
      vehicleMasterid: this.customer.vehicle_id,
      isactive: activeInactiveVal,
      lastmodifiedby:
        `${userInfo.userfirstname}` + " " + `${userInfo.userlastname}`,
    };
    console.log("JJJJJJJJ", customerGetobj);
    // return false;
    this.$http
      .post(
        `${CONSTANTS.MIGRATION_API_URL}/activateinactivatedeliveryagent`,
        customerGetobj
      )
      .then((result) => {
        console.log("result", result);
        if (result.body.returnmsg === "Successfull") {
          // alert("Shipments are Allocated so can not InActive");
          this.$fire({
            text: "Status Changed Successfully",
            type: "success",
            timer: 30000,
          });

          this.toggleInfo = false;
          this.pageNum=1;
          this.displaydata(this.pageNum);
        } else {
          this.$fire({
            text: result.body.returnvalue,
            type: "error",
            timer: 30000,
          });
          this.toggleInfo = false;
        }
      })
      .catch((ex) => {
        console.log("error", ex);
      });
  },
  changePassword(value) {
      this.ovehicle_id = "";
      this.deliveryagentpassword='';
      // alert("innnn");
       console.log("Value",value);
      this.ovehicle_id = value.vehicle_id;

      this.resetPassword = true;
    },
    cancelPassword() {
      console.log("ppppppppp")
      this.deliveryagentpassword='';
      this.sysusermasterid = "";
      this.customer = {};
      this.resetPassword = false;
    },
    validateForm4(scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this.changeVehiclePassword();
        }
      });
    },
    changeVehiclePassword: function() {
      document.getElementById("overlayModal").style.display = "block";
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      console.log("this.vehicle_id", this.ovehicle_id);
      const encryptedText = btoa(this.ovehicle_id);

      console.log("encryptedText", encryptedText);
      const decryptedText = atob(encryptedText);
      console.log("decryptedText", decryptedText);
      var passwObj = {
        vehicle_id: encryptedText,
        password: this.deliveryagentpassword.trim(),
        lastmodifiedby:this.getfullname
      };
      this.$http
        .post(
          `${CONSTANTS.MIGRATION_API_URL}/changeVehicleUserPassword`,
          passwObj
        )
        .then((result) => {
          // console.log("error",result);
          document.getElementById("overlayModal").style.display = "none";
          if (result.body.returnmsg == "Successful") {
            this.$fire({
              text: "Password Updated Successfully",
              type: "success",
              timer: 300000,
            });
            this.deliveryagentpassword = null
            this.resetPassword = false;
            //this.customer = {};
          //  this.displaydata();
          } else {
            this.$fire({
              text: result.body.returnvalue,
              type: "error",
              timer: 300000,
            });
          }
        })
        .catch((ex) => {
          console.log("error", ex);
        });
    },
    comparePayloadsWithKeyMap(oldPayload, newPayload, keyMap) {
  const changes = [];

  for (const key in newPayload) {
    if (newPayload.hasOwnProperty(key) && key !== "optionmailid") {
      if (newPayload[key] !== oldPayload[key]) {
        const mappedKey = keyMap[key] || ""; 
         if(mappedKey){
        changes.push(mappedKey);
         }
      }
    }
  }

  const uniqueArray = [...new Set(changes)];

return uniqueArray.join(", ");

  //return changes.join(", ");
},
VehicleListingLog(){
          var userdata = localStorage.getItem("userData");
          var userInfo = JSON.parse(userdata);

          let obj = { vehicleid:Number(this.getmyvehicleid) }

          this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getAllVehiclelogMaster`,obj)
          .then(result => {
              if(result.body.returnmsg === "Successful"){
                this.vehicle_historylog = result.body.returnvalue;
                
            //  console.log('vehicle_historylog=========>',this.vehicle_historylog)
              }

              else{
                this.vehicle_historylog=[];
               }

          }).catch(ex => {
            console.log('error', ex)
          })
    },

},
filters: {
  datechange: function(value) {
    if (value == null) {
      return "-";
    } else {
      var d = new Date(value);
      var curr_date = (d.getDate() < 10 ? "0" : "") + d.getDate();
      var month = d.getMonth() + 1;
      var curr_year = d.getFullYear();
      var curr_month = month < 10 ? "0" + month : "" + month;
      var hours = d.getHours();
      var minutes = d.getMinutes();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes + " " + ampm;
      return (
        curr_date + "-" + curr_month + "-" + curr_year + "  " + " " + strTime
      );
    }
  },
  capitalize: function(value) {
    if (!value) return "";
    value = value.toString();
    return value.charAt(0).toUpperCase() + value.slice(1);
  },
},
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
opacity: 0;
}
.custom-scrollbar {
position: relative;
height: 200px;
overflow: auto;
}
.table-wrapper-scroll-y {
display: block;
}
.racktd {
text-align: center;
font-weight: bold;
}
.table button {
background: #b0c4de !important;
color: #000 !important;
}
#vendor_list_scroll {
max-height: 500px;
overflow-y: scroll;
}
#table {
text-align: left;
position: relative;
border-collapse: collapse;
}
#th_style {
background: #eceff1;
position: sticky;
top: 0;
box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.4);
}
.masterAction {
width: 100px;
}
/*.volume{
width: 55px !important;
}*/
/*.physicalweight{
width: 80px;
}*/
/*.swal2-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 10px;
}*/
</style>
